var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-source-code",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}svg#freepik_stories-source-code:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-123",
    className: "animable",
    style: {
      transformOrigin: "249.998px 351.691px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-123",
    d: "M77.67 451.2c-95.18-54.95-95.18-144 0-199s249.49-55 344.66 0 95.18 144 0 199-249.49 54.95-344.66 0Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "249.998px 351.691px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-123",
    className: "animable",
    style: {
      transformOrigin: "260.701px 353.288px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-123",
    d: "M216 480.6a24.17 24.17 0 0 1-12-3L53.83 390.88c-5.13-3-8.2-7.94-8.2-13.31s3.07-10.34 8.2-13.31L288.07 229a25.17 25.17 0 0 1 23.93 0l150.16 86.7c5.14 3 8.2 7.94 8.2 13.3s-3.06 10.35-8.2 13.31L227.91 477.58A24.17 24.17 0 0 1 216 480.6Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "257.995px 353.288px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-123",
    className: "animable",
    style: {
      transformOrigin: "390.161px 429.865px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.81 391.72c-22.65-13.08-59.38-13.08-82 0-19.21 11.08-22.12 28-8.77 40.87a9.41 9.41 0 0 0-2.16.88l-59.08 34.18c-3 1.76-3 4.6 0 6.35l4.48 2.59a11.33 11.33 0 0 0 10.82-.3l54.13-36.49a6.84 6.84 0 0 0 .77-.6c22.67 12.95 59.23 12.92 81.81-.12s22.65-34.28 0-47.36Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "390.161px 429.865px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 414.37c0-4.78 3.83-9.44 10.79-13.12 7.69-4.07 18-6.31 29.06-6.31s21.37 2.24 29.07 6.31c7 3.68 10.79 8.34 10.79 13.12s-3.83 9.43-10.79 13.11c-7.7 4.07-18 6.31-29.07 6.31s-21.37-2.24-29.06-6.31c-7.01-3.68-10.79-8.34-10.79-13.11Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "416.855px 414.365px"
    },
    id: "el5np3pblyo19",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-123",
    className: "animable",
    style: {
      transformOrigin: "455.084px 281.158px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-123",
    className: "animable",
    style: {
      transformOrigin: "455.084px 281.158px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m445.12 308.61-7-4s-4.14-17.22-2.49-32.72c2.32-21.8 16.67-30 22.12-28.12s7 8.22-2 21.2c-5.28 7.63-11.82 23.58-10.63 43.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "448.706px 276.06px"
    },
    id: "elo24qs7hmdds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "448.706px 276.06px"
    },
    className: "animable",
    id: "elun0z73dm9l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m445.12 308.61-7-4s-4.14-17.22-2.49-32.72c2.32-21.8 16.67-30 22.12-28.12s7 8.22-2 21.2c-5.28 7.63-11.82 23.58-10.63 43.64Z",
    style: {
      fill: "#fff",
      transformOrigin: "448.706px 276.06px"
    },
    id: "elfqmwho8wmf6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.23 300.15h.07a.49.49 0 0 0 .38-.57c-3.81-20.1 3.21-42.68 11.9-52.08a.5.5 0 0 0 0-.69.51.51 0 0 0-.69 0c-8.85 9.57-16 32.53-12.13 52.92a.48.48 0 0 0 .47.42Z",
    style: {
      fill: "#fff",
      transformOrigin: "447.701px 273.413px"
    },
    id: "el7umu8i5jc2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.65 318.73c1 .53 3.81-1.84 4.58-2.42a9.63 9.63 0 0 0 3-3.84 9 9 0 0 0 .53-5.47 21.76 21.76 0 0 0-.83-2.86l-.95-2.76a7.22 7.22 0 0 1-.55-2.81c.15-1.93 1.78-3.36 3.27-4.59 1.65-1.37 3.34-3.15 3.22-5.46a8.17 8.17 0 0 0-2.28-4.73c-1.17-1.34-2.55-2.51-3.62-3.94a5.67 5.67 0 0 1-1.34-3.53 5.82 5.82 0 0 1 .67-2.28 31.48 31.48 0 0 0 2.22-4.61c.48-1.65.3-3.65-1-4.74a5.28 5.28 0 0 0-4-.79 9.14 9.14 0 0 0-3.63 1.49c-3.56 2.22-5.43 6.66-9.24 8.43a40.82 40.82 0 0 1-4.65 1.39 5.82 5.82 0 0 0-3.75 2.85c-1.28 2.92 1.55 6.3.69 9.38-.75 2.72-3.3 3.88-4.64 6.37a5.74 5.74 0 0 0-.51 3.54 17 17 0 0 0 1.78 5.85 52.66 52.66 0 0 0 3.52 5.41s17.35 10.04 17.51 10.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "457.34px 291.3px"
    },
    id: "eler8t692ian9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "457.34px 291.3px"
    },
    className: "animable",
    id: "elm2jk5qq3btq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.65 318.73c1 .53 3.81-1.84 4.58-2.42a9.63 9.63 0 0 0 3-3.84 9 9 0 0 0 .53-5.47 21.76 21.76 0 0 0-.83-2.86l-.95-2.76a7.22 7.22 0 0 1-.55-2.81c.15-1.93 1.78-3.36 3.27-4.59 1.65-1.37 3.34-3.15 3.22-5.46a8.17 8.17 0 0 0-2.28-4.73c-1.17-1.34-2.55-2.51-3.62-3.94a5.67 5.67 0 0 1-1.34-3.53 5.82 5.82 0 0 1 .67-2.28 31.48 31.48 0 0 0 2.22-4.61c.48-1.65.3-3.65-1-4.74a5.28 5.28 0 0 0-4-.79 9.14 9.14 0 0 0-3.63 1.49c-3.56 2.22-5.43 6.66-9.24 8.43a40.82 40.82 0 0 1-4.65 1.39 5.82 5.82 0 0 0-3.75 2.85c-1.28 2.92 1.55 6.3.69 9.38-.75 2.72-3.3 3.88-4.64 6.37a5.74 5.74 0 0 0-.51 3.54 17 17 0 0 0 1.78 5.85 52.66 52.66 0 0 0 3.52 5.41s17.35 10.04 17.51 10.12Z",
    style: {
      fill: "#fff",
      transformOrigin: "457.34px 291.3px"
    },
    id: "elr5ppe6ktpn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.57 313.47a.45.45 0 0 0 .43-.47c-1.67-18.08 5.86-38.51 11.77-44.64a.45.45 0 0 0-.65-.63c-6 6.24-13.72 27-12 45.35a.44.44 0 0 0 .45.39Z",
    style: {
      fill: "#fff",
      transformOrigin: "458.387px 290.531px"
    },
    id: "el4409zx5pjh6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.36 291.18h.14a61.38 61.38 0 0 1 13-2.79.46.46 0 0 0-.09-.91 62.52 62.52 0 0 0-13.27 2.84.45.45 0 0 0 .18.88Z",
    style: {
      fill: "#fff",
      transformOrigin: "460.836px 289.342px"
    },
    id: "elztpatlvjbb",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-123",
    className: "animable",
    style: {
      transformOrigin: "254.324px 242.883px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-123",
    className: "animable",
    style: {
      transformOrigin: "254.324px 242.883px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.22 372.49c0 3.95 3 8.85 6.59 11l154.41 89.11a14.53 14.53 0 0 0 13.19 0l240.87-139.06c3.64-2.11 6.6-7 6.6-11s-2.95-8.85-6.6-10.95l-154.41-89.11a14.53 14.53 0 0 0-13.19 0L54.81 361.54c-3.64 2.1-6.59 7.01-6.59 10.95Z",
    style: {
      fill: "#37474f",
      transformOrigin: "259.05px 347.54px"
    },
    id: "elb8968tu3jom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.81 369.16 154.41 89.15a14.6 14.6 0 0 0 13.19 0l240.87-139.06c3.65-2.11 3.65-5.52 0-7.62l-154.41-89.15a14.53 14.53 0 0 0-13.19 0L54.81 361.54c-3.64 2.1-3.64 5.51 0 7.62Z",
    style: {
      fill: "#455a64",
      transformOrigin: "259.049px 340.391px"
    },
    id: "eldqdczz8jmat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.82 459.9v14.28a13.44 13.44 0 0 1-6.59-1.57L54.81 383.45c-3.64-2.1-6.6-7-6.6-10.95 0-3.71 2.61-8.25 5.93-10.53-3 2.12-2.73 5.22.67 7.19l154.42 89.16a13.44 13.44 0 0 0 6.59 1.58Z",
    style: {
      fill: "#263238",
      transformOrigin: "132.015px 418.076px"
    },
    id: "elzvdlenf09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.18 362.66 221.35-127.79a6.88 6.88 0 0 1 6.22 0l8.06 4.52c1.72 1 1.72 2.6 0 3.59L89.43 370.75a6.82 6.82 0 0 1-6.22 0l-8-4.5c-1.74-.99-1.74-2.6-.03-3.59Z",
    style: {
      fill: "#263238",
      transformOrigin: "193.001px 302.814px"
    },
    id: "eli21jlywppv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.92 375.48 221.35-127.79a6.34 6.34 0 0 1 5.68-.31l57.61 33.26c1.43.82 1.18 2.29-.53 3.28L159.94 411.54a6.34 6.34 0 0 1-5.69.32l-57.86-33.11c-1.39-.81-1.19-2.28.53-3.27Z",
    style: {
      fill: "#263238",
      transformOrigin: "238.982px 329.619px"
    },
    id: "ely1agjw264nn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.72 301.36 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.78a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1-.05Zm-10.12-13.84-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.16 1.16 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm-22.39 12.93-11.73 6.77c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l11.73-6.77c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm12.26-7.08-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm-27.18 15.69-6.94 4c-.29.18-.32.44 0 .59l6.63 3.82a1.08 1.08 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.68-3.89a1.1 1.1 0 0 0-1 .06Zm-10.13 5.85-6.93 4c-.3.17-.33.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0Zm26 15.62 6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.11 1.11 0 0 0 .98 0ZM247 336.38l6.93-4c.29-.17.32-.43.05-.58l-6.61-3.8a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.44-.06.59l6.63 3.82a1.1 1.1 0 0 0 .99-.03Zm-10.13 5.85 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.02 0Zm-10.13 5.85 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.82a1.09 1.09 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.02-.01Zm51.83-40.87 6.93-4c.3-.17.32-.43.06-.58L279 298.8a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58l6.63 3.83a1.11 1.11 0 0 0 .95 0Zm-11.32 17.47 15.46-8.92c.3-.17.32-.43.06-.58l-16.1-9.3a1.13 1.13 0 0 0-1 0l-8 4.62c-.3.17-.32.43-.06.58l8.52 4.92c.26.15.24.42-.06.59l-6.39 3.69c-.3.17-.33.43-.06.58l6.63 3.83a1.11 1.11 0 0 0 1.02-.01ZM221 320.76l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l6.93-4c.3-.18.33-.44.06-.59l-6.63-3.85a1.08 1.08 0 0 0-1 .03Zm-10.13 5.85-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.64-3.83a1.11 1.11 0 0 0-.96 0Zm-56.05 62.44a1.11 1.11 0 0 0 1 0l6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm-25-15.66-6.93 4c-.3.17-.33.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-.95 0Zm12.84 11.73a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm27.95 6.28 6.93-4c.29-.17.32-.43.06-.58L171 383a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.02-.01Zm-11.14 5.88a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58ZM140 367.54l-6.94 4c-.29.18-.32.44-.05.59l6.63 3.82a1.08 1.08 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.86a1.1 1.1 0 0 0-1 .03Zm50.64-29.24-6.93 4c-.29.17-.32.43-.06.58l6.63 3.82a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 .01Zm-40.52 23.4-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm50.65-29.24-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm-20.26 11.69-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0ZM170.38 350l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.18.32-.44.06-.59l-6.62-3.82a1.1 1.1 0 0 0-1.01 0Zm-10.13 5.85-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm46.25 3.92 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0Zm94.5-85.18-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.86a1.13 1.13 0 0 0-1 .03Zm-12.26 7.08-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.59l-6.63-3.82a1.13 1.13 0 0 0-1.01 0Zm22.39-12.93-6.93 4c-.29.17-.32.44-.06.59l6.63 3.82a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1.01 0Zm-56 52 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.01.01Zm67.12-57.89a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58Zm-105.62 91.07 6.93-4c.29-.17.32-.43.06-.58l-6.62-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 .99 0Zm124.21-71.71 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.59l6.63 3.82a1.13 1.13 0 0 0 1 0Zm-19.6.38 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0Zm10.49-14.26a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.82a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58Zm2.13-1.23 16.1 9.3a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-16.1-9.3a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.48-.06.58Zm-23.4 13-6.93 4c-.29.17-.32.43-.06.58l6.64 3.83a1.1 1.1 0 0 0 1 0l6.93-4c.3-.18.32-.44.06-.59l-6.63-3.92a1.13 1.13 0 0 0-1.01.06Zm-76.23 44-6.93 4c-.29.17-.32.43-.06.58l6.63 3.82a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.62-3.92a1.13 1.13 0 0 0-1.01.07Zm95.48-36a1.1 1.1 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.59l-6.63-3.82a1.08 1.08 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58Zm-85.35 30.14-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1-.01ZM165 383.2a1.11 1.11 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58Zm-11.8-12.34-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0Zm22.91 6.46 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.82a1.1 1.1 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.05.58l6.63 3.83a1.1 1.1 0 0 0 .99-.01Zm10.13-5.85 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0Zm10.13-5.85 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.44-.06.59l6.63 3.82a1.13 1.13 0 0 0 1 0Zm-33-.61-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.05-.58l-6.66-3.84a1.08 1.08 0 0 0-1 0Zm10.13-5.85-6.93 4c-.3.17-.33.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1.04 0Zm40.5-23.39-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.16.32-.43.06-.58l-6.63-3.86a1.1 1.1 0 0 0-1 .03Zm-10.13 5.85-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1.03 0Zm20.26-11.7-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1.03 0Zm-40.51 23.39-6.93 4c-.3.16-.33.43-.06.58l6.63 3.82a1.08 1.08 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1.03.01Zm10.12-5.84-6.93 4c-.29.17-.32.43-.05.58l6.63 3.83a1.11 1.11 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1.04 0Zm-12.92 38.08 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 .97 0ZM127.37 383l-6.63-3.82a1.08 1.08 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l6.93-4c.3-.15.33-.41.06-.59Zm13.21 3.32-6.58-3.8a1.13 1.13 0 0 0-1 0l-10.66 6.16c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l10.66-6.15c.24-.18.27-.44.01-.59Zm-23.1-10.88-6.63-3.82a1.1 1.1 0 0 0-1 0l-8.53 4.92c-.29.17-.32.43-.06.59l6.63 3.82a1.13 1.13 0 0 0 1 0l8.53-4.93c.29-.14.32-.4.06-.55Zm6.52-3.74a1.11 1.11 0 0 0 1 0l6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm28.69 18.58-6.63-3.83a1.1 1.1 0 0 0-1 0l-13.33 7.7c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l13.33-7.69c.37-.18.37-.44.08-.59Zm4.68 8.24-6.63-3.83a1.13 1.13 0 0 0-1 0l-8.53 4.93c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l8.53-4.92c.31-.18.34-.44.08-.59Zm41.94-70.3a1.11 1.11 0 0 0 1 0l6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm-20.26 11.69a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.59Zm-44.92 25.94a1.1 1.1 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58Zm55-31.78a1.11 1.11 0 0 0 1 0l6.94-4c.29-.17.32-.43.05-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm-20.26 11.69a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.59l-6.63-3.82a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm-6.58 53.17a1.08 1.08 0 0 0-1 0l-10.67 6.16c-.29.16-.32.43-.06.58l6.63 3.82a1.09 1.09 0 0 0 1 0l10.66-6.16c.3-.17.32-.43.06-.58Zm-8-44.78a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.59ZM144.27 360a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58ZM350 290.58a1.13 1.13 0 0 0-1 0l-17 9.89c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l17.02-9.88c.29-.17.32-.43.06-.58Zm-22.39 12.93a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58Zm-136.72 76.2 6.94-4c.29-.18.32-.44.05-.59l-6.63-3.82a1.08 1.08 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1.02 0Zm116.46-64.5a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.59Zm52.77-30.47a1.08 1.08 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l6.94-4c.29-.17.32-.43.06-.58Zm16.76-2-16.1-9.3a1.1 1.1 0 0 0-1 0l-6.94 4c-.29.17-.32.44-.05.59l16.1 9.29a1.1 1.1 0 0 0 1 0l6.93-4c.32-.19.35-.45.08-.6Zm-107.36 54.32a1.13 1.13 0 0 0-1 0L260 342c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l8.53-4.92c.29-.17.32-.43.06-.58Zm25.59-14.77a1.09 1.09 0 0 0-1 0l-10.66 6.16c-.3.17-.32.43-.06.58l6.63 3.83a1.11 1.11 0 0 0 1 0l10.67-6.16c.29-.17.32-.43.06-.58Zm-49.05 28.31a1.13 1.13 0 0 0-1 0l-57 32.93c-.29.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0l57-32.93c.3-.17.32-.43.06-.58Zm-60.24 34.78a1.13 1.13 0 0 0-1 0l-8.53 4.92c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l8.53-4.93c.29-.17.32-.43.06-.58Zm72-41.55a1.13 1.13 0 0 0-1 0l-8.53 4.92c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l8.53-4.92c.29-.17.32-.43.06-.58Zm-83.7 48.32a1.13 1.13 0 0 0-1 0l-8.53 4.92c-.29.17-.32.43-.05.58l6.63 3.83a1.1 1.1 0 0 0 1 0l8.53-4.93c.3-.17.32-.43.06-.58Zm107.16-61.86a1.13 1.13 0 0 0-1 0l-8.53 4.93c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1 0l8.53-4.92c.29-.17.32-.43.06-.58Zm36.25-20.93a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.59l6.63 3.82a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58Zm22.68-15.83 6.93-4c.3-.17.33-.43.06-.58l-6.63-3.82a1.08 1.08 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 .97-.01Zm-41.33 2 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.82a1.1 1.1 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 .97-.02ZM272 332.92l20.26-11.69c.29-.17.32-.43.05-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0l-20.26 11.7c-.3.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.01-.01Zm57.1-33.51a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.68-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm-8.47-5.51 6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58l6.63 3.83a1.11 1.11 0 0 0 .95 0Zm-58.76 44.87 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.82a1.1 1.1 0 0 0 .95.01Zm44.84-26.43a1.11 1.11 0 0 0 1 0l6.94-4c.29-.17.32-.43 0-.58l-6.65-3.87a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58ZM211.17 368l6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58l6.63 3.82a1.08 1.08 0 0 0 1 .01Zm10.13-5.85 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.11 1.11 0 0 0-1 0l-6.94 4c-.29.17-.32.43-.06.58l6.64 3.83a1.11 1.11 0 0 0 1 .01ZM201 373.86l6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0Zm40.52-23.39 6.93-4c.29-.17.32-.44.06-.59l-6.63-3.82a1.1 1.1 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.04 0Zm-10.13 5.84 6.93-4c.3-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.04 0Zm20.26-11.69 6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58l6.63 3.83a1.13 1.13 0 0 0 1.04 0ZM307 263.26a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-1.77-1a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.59Zm-50.34 31.88a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.05-.58L258 286.7a1.08 1.08 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm20.26-11.7a1.08 1.08 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-6.67-3.86a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.16-.33.43-.06.58Zm-32.63 18.84a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.59l-6.63-3.82a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58Zm22.5-13a1.1 1.1 0 0 0 1 0l6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58ZM224 314a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58Zm10.13-5.85a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58ZM286.7 275a1.13 1.13 0 0 0 1 0l6.93-4c.3-.16.32-.43.06-.58l-1.76-1a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58Zm30.39-17.54a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-1.77-1a1.11 1.11 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm13.93 8a1.13 1.13 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.62-3.88a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm19.29 22.22 6.93-4c.3-.17.33-.43.06-.58l-6.63-3.83a1.1 1.1 0 0 0-1 0l-6.93 4c-.3.17-.33.43-.06.58l6.63 3.83a1.1 1.1 0 0 0 1 0Zm-53.48-18.57a1.13 1.13 0 0 0 1 0l6.93-4c.3-.17.32-.43.06-.58l-1.76-1a1.13 1.13 0 0 0-1 0l-6.93 4c-.3.17-.32.43-.06.58Zm-83 50.71a1.1 1.1 0 0 0 1 0l6.93-4c.29-.17.32-.43.06-.58l-6.63-3.83a1.13 1.13 0 0 0-1 0l-6.93 4c-.29.17-.32.43-.06.58Z",
    style: {
      fill: "#455a64",
      transformOrigin: "239.083px 330.686px"
    },
    id: "el8tweccvm4x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "303.155px 370.315px"
    },
    id: "elv5jztmhj0ff",
    className: "animable",
    d: "m246.06 379.3 1.5.87 40.03 23.1 71.18-41.09 1.48-.85-41.53-23.97-72.66 41.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "303.17px 371.7px"
    },
    id: "el1cwj9mq2tsf",
    className: "animable",
    d: "m357.86 362.71-39.14-22.58-70.24 40.57 39.11 22.57 70.27-40.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 361.78c-3.42-2-3.23-5.31-3.23-9.51V163.63a14.56 14.56 0 0 1 6.59-11.42l240.9-139.07c3.64-2.1 8.94-2.12 12 .34s4 4.73 4 8.94v188.63a14.61 14.61 0 0 1-6.6 11.43L54.81 361.54c-3.64 2.1-9.36 2.21-12.81.24Z",
    style: {
      fill: "#37474f",
      transformOrigin: "170.514px 187.393px"
    },
    id: "elem7gig5xhyl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.28 22.41c0-4.2-3-5.9-6.6-3.81L54.81 157.67a13.47 13.47 0 0 0-4.66 4.94l-9.41-5.48a13.55 13.55 0 0 1 4.67-4.93L286.26 13.14c3.64-2.11 8.95-2.15 12 .34 3.26 2.62 4.02 4.73 4.02 8.93Z",
    style: {
      fill: "#455a64",
      transformOrigin: "171.51px 87.0966px"
    },
    id: "elepu73393vwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 361.94c-3.64 1.71-8.82 1.67-12-.17-3.41-2-3.23-5.3-3.23-9.5V163.62a13.29 13.29 0 0 1 1.93-6.48l9.42 5.45a13.51 13.51 0 0 0-1.94 6.49v188.65c.03 3.9 2.58 5.66 5.82 4.21Z",
    style: {
      fill: "#263238",
      transformOrigin: "46.3842px 260.164px"
    },
    id: "el363clct8aqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.36 165.28 231.8-133.79c2.18-1.26 3.95-.24 3.95 2.29V209.2a8.75 8.75 0 0 1-3.95 6.86L58.36 349.85c-2.19 1.26-4 .24-4-2.29V172.14a8.74 8.74 0 0 1 4-6.86Z",
    id: "el4h1oa6gzwcq",
    className: "animable",
    style: {
      transformOrigin: "174.235px 190.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36 165.28a8.74 8.74 0 0 0-4 6.86V344.5l229.19-132.26a8.73 8.73 0 0 0 4-6.85V33Z",
    style: {
      fill: "#263238",
      transformOrigin: "170.955px 188.75px"
    },
    id: "elppsb74l3dc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-123",
    className: "animable",
    style: {
      transformOrigin: "199.84px 201.957px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-123",
    className: "animable",
    style: {
      transformOrigin: "199.84px 201.957px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "195.375px 199.377px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.11 372.27-.65-.38a4.21 4.21 0 0 1-1.91-3.3v-188.8l239.28-138a4.19 4.19 0 0 1 3.81 0l.65.38a4.22 4.22 0 0 1 1.91 3.3v186.45a4.25 4.25 0 0 1-1.9 3.3l-237.38 137a4.26 4.26 0 0 1-3.81.05Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "195.375px 207.013px"
    },
    id: "elb9e4d8tks4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.07 372c-.44 0-.5-.51-.5-.81V182.71L317.65 44.15v186.66a5.82 5.82 0 0 1-2.6 4.49L78.65 371.79a1.27 1.27 0 0 1-.58.21Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "197.61px 208.075px"
    },
    id: "elalff2vxdi7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1 45.1v185.7a5.28 5.28 0 0 1-2.32 4L78.37 371.31a.78.78 0 0 1-.23.1 1.25 1.25 0 0 1 0-.24V183.01L317.1 45.1m1.1-1.91L77.05 182.38v188.79c0 .86.43 1.36 1 1.36a1.76 1.76 0 0 0 .85-.26l236.43-136.49a6.38 6.38 0 0 0 2.87-5V43.19Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "197.625px 207.86px"
    },
    id: "el0n6obd5cf3tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48 372.46a4.25 4.25 0 0 1-3.36-.19l-.66-.39a4.18 4.18 0 0 1-1.91-3.3V179.79l4.5 2.59v188.79c-.05 1.03.58 1.55 1.43 1.29Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "75.515px 276.254px"
    },
    id: "elqhpkutkmm6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48 372.46a4.25 4.25 0 0 1-3.36-.19l-.66-.39a4.18 4.18 0 0 1-1.91-3.3V179.79l4.5 2.59v188.79c-.05 1.03.58 1.55 1.43 1.29Z",
    style: {
      opacity: 0.1,
      transformOrigin: "75.515px 276.254px"
    },
    className: "animable",
    id: "elxg6n222d38"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "195.375px 104.208px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.55 179.79v-12.58a5.27 5.27 0 0 1 2.4-4.15L311.31 26.64a5.1 5.1 0 0 1 4.64-.09 5.15 5.15 0 0 1 2.25 4.06v12.58L77.05 182.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "195.375px 104.208px"
    },
    id: "elr34ha3i3fue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.17 30.22c-.16-1.24-1.17-1.69-2.36-1L79.44 165.65a5.12 5.12 0 0 0-1.69 1.79l-4.49-2.6a4.92 4.92 0 0 1 1.74-1.78L311.31 26.64a5.1 5.1 0 0 1 4.64-.09 5.1 5.1 0 0 1 2.22 3.67Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "195.715px 96.7378px"
    },
    className: "animable",
    id: "eljrkmgaoxfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.05 182.38V169.8a4.88 4.88 0 0 1 .7-2.36l-4.49-2.6c-.12.21-.22.43-.32.65l-.09.26c0 .14-.1.28-.14.42a4.21 4.21 0 0 0-.15 1v12.58Z",
    style: {
      opacity: 0.2,
      transformOrigin: "75.155px 173.61px"
    },
    className: "animable",
    id: "elm0f42cv2cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.33 38.2c1-.59 1.84-.11 1.84 1.06a4 4 0 0 1-1.84 3.18c-1 .59-1.83.12-1.83-1.06a4.07 4.07 0 0 1 1.83-3.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "311.335px 40.3209px"
    },
    id: "ellwef4x2vsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72 42c1-.59 1.84-.12 1.84 1.06a4.08 4.08 0 0 1-1.84 3.18c-1 .58-1.84.11-1.84-1.06a4 4 0 0 1 1.84-3.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "304.72px 44.1169px"
    },
    id: "elgrt5w6xw2ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1 45.83c1-.59 1.84-.11 1.84 1.06a4 4 0 0 1-1.84 3.18c-1 .59-1.83.11-1.83-1.06a4.06 4.06 0 0 1 1.83-3.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "298.105px 47.95px"
    },
    id: "el2g81ygl2255",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-123",
    className: "animable",
    style: {
      transformOrigin: "204.305px 212.21px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.05 377.42-.66-.37a4.23 4.23 0 0 1-1.91-3.3V187.32a4.2 4.2 0 0 1 1.91-3.32l5.23-3a4.82 4.82 0 0 0 2.29-3l3.47-14a4.86 4.86 0 0 1 2.3-3.05l49.74-28.72a4.13 4.13 0 0 1 4.11 0l1.18.68a4.1 4.1 0 0 1 1.76 2l2.8 6.94L320.76 47a4.19 4.19 0 0 1 3.81 0l.66.38a4.21 4.21 0 0 1 1.9 3.3v186.4a4.22 4.22 0 0 1-1.9 3.3l-237.37 137a4.19 4.19 0 0 1-3.81.04Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "204.305px 212.2px"
    },
    id: "elarct1iq16v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 377.14c-.44 0-.51-.51-.51-.82V191a5.83 5.83 0 0 1 2.6-4.5l4.26-2.46a5.43 5.43 0 0 0 2.55-3.39l3.47-14a4.36 4.36 0 0 1 2-2.7l49.87-28.8a1.39 1.39 0 0 1 .76-.15 1.37 1.37 0 0 1 1.28.86l3.4 8.43a2.49 2.49 0 0 0 3.54 1.22L325.5 50a1.24 1.24 0 0 1 .58-.18c.44 0 .5.5.5.81V236a5.82 5.82 0 0 1-2.59 4.5L87.58 377a1.23 1.23 0 0 1-.58.14Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "206.535px 213.48px"
    },
    id: "elwc0w8cm8vdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 50.41a1.29 1.29 0 0 1 0 .25V236a5.28 5.28 0 0 1-2.32 4L87.31 376.47a.91.91 0 0 1-.23.1.73.73 0 0 1 0-.25V191a5.28 5.28 0 0 1 2.32-4l4.27-2.46a6 6 0 0 0 2.81-3.74l3.47-14a3.78 3.78 0 0 1 1.77-2.36l49.88-28.79a.77.77 0 0 1 .41-.11.81.81 0 0 1 .77.52l3.4 8.42a3 3 0 0 0 2.81 1.9 3.14 3.14 0 0 0 1.52-.4l165.3-95.44a.78.78 0 0 1 .23-.1m.07-1.11a1.66 1.66 0 0 0-.85.26L159.93 145a1.93 1.93 0 0 1-2.76-1l-3.4-8.42a1.91 1.91 0 0 0-1.79-1.21 1.94 1.94 0 0 0-1 .25l-49.88 28.8a4.88 4.88 0 0 0-2.29 3l-3.47 14a4.89 4.89 0 0 1-2.29 3l-4.27 2.47A6.35 6.35 0 0 0 86 191v185.3c0 .87.43 1.36 1 1.36a1.72 1.72 0 0 0 .86-.26l236.4-136.49a6.35 6.35 0 0 0 2.87-5V50.66c0-.87-.43-1.36-1.05-1.36Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "206.565px 213.48px"
    },
    id: "elmp07najfd1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.13 50.66c0-1.22-.85-1.71-1.9-1.1L159.93 145a1.93 1.93 0 0 1-2.76-1l-3.4-8.42a1.93 1.93 0 0 0-2.75-1l-49.88 28.8a4.88 4.88 0 0 0-2.29 3l-3.47 14a4.89 4.89 0 0 1-2.29 3l-4.27 2.47A6.35 6.35 0 0 0 86 191v12.15L327.13 63.93Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "206.565px 126.224px"
    },
    id: "elnrcgv9yc46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.42 377.62a4.27 4.27 0 0 1-3.37-.19l-.66-.39a4.19 4.19 0 0 1-1.9-3.3V187.33a4 4 0 0 1 .64-2l4.76 2.74a6 6 0 0 0-.94 3v185.26c.05 1.03.62 1.55 1.47 1.29Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "84.455px 281.604px"
    },
    id: "el3lvx2kvpsk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.42 377.62a4.27 4.27 0 0 1-3.37-.19l-.66-.39a4.19 4.19 0 0 1-1.9-3.3V187.33a4 4 0 0 1 .64-2l4.76 2.74a6 6 0 0 0-.94 3v185.26c.05 1.03.62 1.55 1.47 1.29Z",
    style: {
      opacity: 0.1,
      transformOrigin: "84.455px 281.604px"
    },
    className: "animable",
    id: "elhmuwclj7c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.44 190-4 2.33 1.54-3a.74.74 0 0 0 0-.72c-.12-.14-.33 0-.46.22l-2.19 4.2a.76.76 0 0 0-.06.16s0 0 0 .05a.76.76 0 0 0 0 .21.5.5 0 0 0 0 .19s0 .07.06.09l2.19 1.68a.2.2 0 0 0 .21 0 .78.78 0 0 0 .25-.32c.12-.27.1-.58 0-.68l-1.54-1.18 4-2.33a.85.85 0 0 0 .32-.69c0-.21-.14-.33-.32-.21Z",
    style: {
      opacity: 0.2,
      transformOrigin: "93.0106px 191.997px"
    },
    className: "animable",
    id: "el9bssa08yfrt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.81 188 4-2.33-1.53-1.18c-.14-.1-.15-.41 0-.68s.32-.42.45-.32l2.19 1.69.06.09a.54.54 0 0 1 0 .19.76.76 0 0 1 0 .21v.06l-.06.15-2.19 4.2a.6.6 0 0 1-.21.25.18.18 0 0 1-.24 0 .72.72 0 0 1 0-.72l1.53-3-4 2.33c-.18.1-.33 0-.33-.31a.85.85 0 0 1 .33-.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "101.234px 186.917px"
    },
    className: "animable",
    id: "eltiyiccx4cv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 176.44c0-.25-.23-.21-.34.05l-.55 1.35c-.94-.1-2.09.81-2.85 2.45-1 2.11-1 4.61 0 5.57a1.41 1.41 0 0 0 1.8.1 4.82 4.82 0 0 0 1.81-2.19.68.68 0 0 0 0-.71c-.12-.12-.33 0-.45.27-.75 1.57-2 2.27-2.71 1.56s-.74-2.59 0-4.16c.53-1.13 1.3-1.79 2-1.83l-.41 1c-.11.26 0 .51.16.4l1.64-1.08a.52.52 0 0 0 .18-.45Z",
    style: {
      opacity: 0.2,
      transformOrigin: "109.896px 181.255px"
    },
    className: "animable",
    id: "eld5movoer5bu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.94 142.55 1.47-3.11a1 1 0 0 0 0-1c-.18-.17-.46 0-.63.36l-1.47 3.2-1.47-1.41c-.17-.17-.45 0-.63.36a1 1 0 0 0 0 1l1.47 1.41-1.47 3.11a1 1 0 0 0 0 1 .27.27 0 0 0 .32 0 .85.85 0 0 0 .31-.39l1.47-3.11 1.47 1.42a.25.25 0 0 0 .31 0 .86.86 0 0 0 .32-.39 1 1 0 0 0 0-1Z",
    style: {
      opacity: 0.2,
      transformOrigin: "150.31px 142.948px"
    },
    className: "animable",
    id: "el3dk8en2fei8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.32 179.42v-3a5.68 5.68 0 0 1 2.57-4.45L310.45 61.5c1.42-.82 2.57-.16 2.57 1.48v3a5.68 5.68 0 0 1-2.57 4.45L118.89 180.9c-1.42.82-2.57.16-2.57-1.48Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "214.67px 121.2px"
    },
    id: "ellsbf8eh9m5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2 70.67a.41.41 0 0 1-.16 0 .5.5 0 0 1-.28-.56l.18-1.53-.71-.51a.48.48 0 0 1-.2-.41.82.82 0 0 1 .3-.65l1.09-.84a.17.17 0 0 0 .05-.09l.49-1.6a.66.66 0 0 1 .55-.51.43.43 0 0 1 .42.25l.41.87.92-.35a.44.44 0 0 1 .5.11.69.69 0 0 1 0 .75l-.76 1.45v.09l.18 1.34a.85.85 0 0 1-.23.67.56.56 0 0 1-.43.17l-.89-.11-1 1.22a.52.52 0 0 1-.43.24Zm-.52-3.1.71.52a.51.51 0 0 1 .19.51l-.12 1 .64-.82a.52.52 0 0 1 .49-.23l.89.11a.26.26 0 0 0 0-.1l-.19-1.34a.83.83 0 0 1 .09-.48l.69-1.3-.71.28a.44.44 0 0 1-.56-.23l-.32-.68-.43 1.42a1 1 0 0 1-.27.41l-1.09.83a.26.26 0 0 0-.01.1Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "308.45px 67.3235px"
    },
    id: "eloe5tgydr4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "320.147px 60.4615px"
    },
    className: "animable",
    id: "elbtdiv0ir3ih"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.43 59.56a.65.65 0 0 1-.58-.34.66.66 0 0 1 .24-.91l5.44-3.15a.68.68 0 0 1 .92.25.67.67 0 0 1-.25.91l-5.44 3.15a.66.66 0 0 1-.33.09Z",
    id: "elar7axd8ol8h",
    className: "animable",
    style: {
      transformOrigin: "320.147px 57.3165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43 62.7a.66.66 0 0 1-.58-.33.67.67 0 0 1 .24-.92l5.44-3.14a.67.67 0 0 1 .92.24.68.68 0 0 1-.25.92l-5.44 3.14a.66.66 0 0 1-.33.09Z",
    id: "elvv85q9sfqzk",
    className: "animable",
    style: {
      transformOrigin: "320.147px 60.4584px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43 65.85a.65.65 0 0 1-.58-.34.67.67 0 0 1 .24-.92l5.44-3.14a.68.68 0 0 1 .92.25.67.67 0 0 1-.25.91l-5.44 3.15a.66.66 0 0 1-.33.09Z",
    id: "ela50wciqwra",
    className: "animable",
    style: {
      transformOrigin: "320.147px 63.6065px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m126.71 191.94.63-5.51a.9.9 0 0 1 .12-.39.53.53 0 0 1 .19-.2l1.29-.75a.13.13 0 0 1 .16 0 .28.28 0 0 1 .06.2.72.72 0 0 1 0 .13l-1.28 10.36a1.25 1.25 0 0 1-.15.49 1 1 0 0 1-.34.38l-.82.47a.26.26 0 0 1-.32 0 .65.65 0 0 1-.18-.3l-.74-3-.74 3.88a2 2 0 0 1-.17.49.86.86 0 0 1-.33.37l-.82.47a.29.29 0 0 1-.33 0 .4.4 0 0 1-.16-.31l-1.28-8.89a.57.57 0 0 1 0-.12.54.54 0 0 1 .07-.27.42.42 0 0 1 .15-.19l1.3-.75a.19.19 0 0 1 .18 0c.06 0 .1.11.12.25l.64 4.78.58-3.09a1.68 1.68 0 0 1 .09-.33.52.52 0 0 1 .25-.31l.93-.54c.12-.06.2-.06.24 0a.64.64 0 0 1 .09.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "125.33px 192.072px"
    },
    id: "elp9kbyfeshk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09 189.77a.15.15 0 0 1 .19 0 .36.36 0 0 1 .08.25v1.61a.88.88 0 0 1-.08.34.57.57 0 0 1-.19.23l-4.69 2.7a.14.14 0 0 1-.19 0 .33.33 0 0 1-.08-.24v-9.84a.81.81 0 0 1 .08-.34.5.5 0 0 1 .19-.23l4.61-2.66a.15.15 0 0 1 .19 0 .33.33 0 0 1 .08.24v1.62a.8.8 0 0 1-.08.33.61.61 0 0 1-.19.24l-3 1.75v1.65l2.83-1.63a.14.14 0 0 1 .19 0 .33.33 0 0 1 .08.24v1.62a.8.8 0 0 1-.08.33.45.45 0 0 1-.19.23l-2.84 1.66v1.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "132.745px 188.247px"
    },
    id: "elpq3xkwhpnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76 191.24a.15.15 0 0 1-.19 0 .34.34 0 0 1-.08-.25v-9.84a.8.8 0 0 1 .08-.33.5.5 0 0 1 .19-.23l3.19-1.84a2.15 2.15 0 0 1 1.11-.37 1 1 0 0 1 .73.31 1.77 1.77 0 0 1 .39.8 4.62 4.62 0 0 1 .12 1.07 4.92 4.92 0 0 1-.06.8c-.05.25-.1.46-.16.66a4.13 4.13 0 0 1-.18.48c-.06.13-.11.24-.15.31a1.12 1.12 0 0 1 .54.64 4 4 0 0 1 .15 1.22 7.18 7.18 0 0 1-.12 1.28 5.82 5.82 0 0 1-.39 1.29 4.89 4.89 0 0 1-.71 1.15 3.61 3.61 0 0 1-1.07.9Zm3.7-9.57a.76.76 0 0 0-.15-.54c-.11-.1-.25-.09-.45 0l-1.54.89v1.73l1.54-.88a1.15 1.15 0 0 0 .45-.5 1.72 1.72 0 0 0 .15-.7Zm-2.14 6.33 1.68-1a1.29 1.29 0 0 0 .47-.55 1.7 1.7 0 0 0 .18-.76.72.72 0 0 0-.18-.56.36.36 0 0 0-.47 0l-1.64.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "139.465px 184.827px"
    },
    id: "elf2r8nd9wyqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.38 174.9a1.93 1.93 0 0 1 1.06-.32 1.39 1.39 0 0 1 .78.25 1.43 1.43 0 0 1 .49.62 2.11 2.11 0 0 1 .18.76.53.53 0 0 1-.06.27.52.52 0 0 1-.16.19l-.4.23c-.08 0-.13.06-.18 0s-.09-.08-.13-.2a1.77 1.77 0 0 0-.16-.29.93.93 0 0 0-.31-.28 1 1 0 0 0-.47-.11 1.3 1.3 0 0 0-.64.21 2.52 2.52 0 0 0-.53.41 3 3 0 0 0-.45.55 2.82 2.82 0 0 0-.32.68 2.46 2.46 0 0 0-.12.76 1.38 1.38 0 0 0 .11.61.59.59 0 0 0 .37.28 1.81 1.81 0 0 0 .64 0l.94-.13a3.2 3.2 0 0 1 .95-.05 1.16 1.16 0 0 1 .64.25 1 1 0 0 1 .36.58 3.23 3.23 0 0 1 .12.95 5 5 0 0 1-.2 1.37 5.19 5.19 0 0 1-.54 1.29 5.7 5.7 0 0 1-.83 1.12 5 5 0 0 1-1.09.86 2.36 2.36 0 0 1-1.06.35 1.32 1.32 0 0 1-.83-.19 1.42 1.42 0 0 1-.55-.59 1.93 1.93 0 0 1-.22-.87.54.54 0 0 1 .07-.27.38.38 0 0 1 .15-.19l.41-.23a.19.19 0 0 1 .17 0c.05 0 .09.07.13.19a1.26 1.26 0 0 0 .19.36.75.75 0 0 0 .33.28.9.9 0 0 0 .5.08 1.64 1.64 0 0 0 .71-.25 3.05 3.05 0 0 0 .65-.5 3.57 3.57 0 0 0 .55-.67 3.38 3.38 0 0 0 .38-.76 2.54 2.54 0 0 0 .14-.8 1 1 0 0 0-.16-.59.76.76 0 0 0-.46-.24 2.16 2.16 0 0 0-.72 0c-.29 0-.62.09-1 .16a2 2 0 0 1-.84 0 1 1 0 0 1-.56-.32 1.44 1.44 0 0 1-.32-.63 4 4 0 0 1-.09-.9 5.1 5.1 0 0 1 .15-1.19 5.68 5.68 0 0 1 .44-1.19 5.19 5.19 0 0 1 .73-1.09 3.91 3.91 0 0 1 1.06-.81Z",
    style: {
      fill: "#455a64",
      transformOrigin: "146.43px 180.349px"
    },
    id: "elqrp859ttaoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63 183.26a.15.15 0 0 1-.19 0 .34.34 0 0 1-.08-.25v-9.84a.8.8 0 0 1 .08-.33.5.5 0 0 1 .19-.23l.41-.24a.14.14 0 0 1 .18 0 .29.29 0 0 1 .08.24v9.84a.71.71 0 0 1-.08.34.49.49 0 0 1-.18.23Z",
    style: {
      fill: "#455a64",
      transformOrigin: "150.831px 177.816px"
    },
    id: "eltkhy0h659h9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29 168.75a.15.15 0 0 1 .19 0 .33.33 0 0 1 .08.24v.55a.8.8 0 0 1-.08.33.57.57 0 0 1-.19.23l-1.85 1.07v8.88a.81.81 0 0 1-.08.34.45.45 0 0 1-.19.23l-.4.23a.14.14 0 0 1-.19 0 .33.33 0 0 1-.08-.24v-8.89l-1.85 1.07a.15.15 0 0 1-.19 0 .33.33 0 0 1-.08-.24V172a.84.84 0 0 1 .08-.34.57.57 0 0 1 .19-.23Z",
    style: {
      fill: "#455a64",
      transformOrigin: "154.97px 174.802px"
    },
    id: "el09ow9301fnl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9 174.81a.14.14 0 0 1 .19 0 .33.33 0 0 1 .08.24v.55a.84.84 0 0 1-.08.34.5.5 0 0 1-.19.23l-4 2.31a.14.14 0 0 1-.18 0 .29.29 0 0 1-.08-.24v-9.84a.68.68 0 0 1 .08-.34.49.49 0 0 1 .18-.23l3.92-2.26a.15.15 0 0 1 .19 0 .34.34 0 0 1 .08.25v.54a.81.81 0 0 1-.08.34.5.5 0 0 1-.19.23l-3.24 1.87v3.2l3-1.75h.19a.32.32 0 0 1 .08.25v.55a.67.67 0 0 1-.08.33.45.45 0 0 1-.19.23l-3 1.75v3.34Z",
    style: {
      fill: "#455a64",
      transformOrigin: "160.904px 172.024px"
    },
    id: "el5l2qq6dffor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.06 133.1-16.53 9.56a2.8 2.8 0 0 0-1.3 2.15c0 .78.59 1.07 1.3.66l16.53-9.56a2.77 2.77 0 0 0 1.3-2.16c0-.75-.58-1.07-1.3-.65Z",
    style: {
      fill: "#263238",
      transformOrigin: "216.795px 139.285px"
    },
    id: "ellwxsqj6uoaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.64 118.93-13 7.51a2.76 2.76 0 0 0-1.3 2.15c0 .78.58 1.07 1.3.66l13-7.51a2.79 2.79 0 0 0 1.3-2.16c0-.77-.58-1.07-1.3-.65Z",
    style: {
      fill: "#455a64",
      transformOrigin: "243.14px 124.088px"
    },
    id: "el1n0d009xmyy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 106-10.8 6.23a2.79 2.79 0 0 0-1.3 2.16c0 .78.58 1.07 1.3.66l10.8-6.24a2.83 2.83 0 0 0 1.3-2.15c.01-.75-.58-1.04-1.3-.66Z",
    style: {
      fill: "#455a64",
      transformOrigin: "266.6px 110.534px"
    },
    id: "elbeupwni1tga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.11 89.81-16.53 9.56a2.77 2.77 0 0 0-1.3 2.15c0 .78.58 1.07 1.3.66l16.53-9.56a2.79 2.79 0 0 0 1.29-2.16c0-.77-.58-1.07-1.29-.65Z",
    style: {
      fill: "#455a64",
      transformOrigin: "291.84px 95.9926px"
    },
    id: "elbt69hv6ogs5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "206.54px 193.88px"
    },
    id: "elzgx9ijpdq0i",
    className: "animable",
    d: "m85.95 302.15 241.18-139.24v-77.3L85.95 224.84v77.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.75 216.67 44.36-25.62c1.32-.76 2.38-.14 2.38 1.38v.44a5.32 5.32 0 0 1-2.39 4.12l-44.34 25.6c-1.31.76-2.38.14-2.38-1.38v-1.52c-.01-1.51 1.05-2.26 2.37-3.02Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "141.935px 206.82px"
    },
    id: "el9d9bd6j2y5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.75 227 28.91-16.69c1.32-.76 2.38-.15 2.38 1.37v.44a5.29 5.29 0 0 1-2.39 4.12l-28.91 16.66c-1.31.76-2.38.14-2.38-1.37V230c.01-1.51 1.07-2.26 2.39-3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "134.2px 221.604px"
    },
    id: "elmvkwh13vuoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.75 227 28.91-16.69c1.32-.76 2.38-.15 2.38 1.37v.44a5.29 5.29 0 0 1-2.39 4.12l-28.91 16.66c-1.31.76-2.38.14-2.38-1.37V230c.01-1.51 1.07-2.26 2.39-3Z",
    style: {
      fill: "#fff",
      opacity: 0.55,
      transformOrigin: "134.2px 221.604px"
    },
    className: "animable",
    id: "elzachbme57y9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36 245.72a.39.39 0 0 1-.35-.2.41.41 0 0 1 .15-.57L202 196a.41.41 0 0 1 .41.71l-84.86 49a.5.5 0 0 1-.19.01Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "159.78px 220.837px"
    },
    id: "el5q4g6nq480l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36 250.88a.41.41 0 0 1-.2-.77l31.26-18.05a.42.42 0 0 1 .57.15.43.43 0 0 1-.15.57l-31.27 18a.39.39 0 0 1-.21.1Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.994px 241.442px"
    },
    id: "el82i3mbgpvg2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1 230.25a.41.41 0 0 1-.21-.77l17.86-10.31a.42.42 0 0 1 .57.15.42.42 0 0 1-.15.56L153.3 230.2a.46.46 0 0 1-.2.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "162.024px 224.682px"
    },
    id: "el55jigc45d64",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.37 217.39a.4.4 0 0 1-.35-.21.4.4 0 0 1 .15-.56l26.83-15.5a.41.41 0 1 1 .41.71l-26.85 15.5a.37.37 0 0 1-.19.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "188.791px 209.226px"
    },
    id: "el276zdh8ykj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36 256a.4.4 0 0 1-.35-.21.4.4 0 0 1 .15-.56l13.4-7.74a.41.41 0 0 1 .56.15.42.42 0 0 1-.15.57l-13.4 7.79a.37.37 0 0 1-.21 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "124.063px 251.725px"
    },
    id: "elzymay52nq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23 245.72a.42.42 0 0 1-.36-.2.43.43 0 0 1 .13-.52l31.27-18a.41.41 0 0 1 .41.72l-31.26 18a.54.54 0 0 1-.19 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "150.86px 236.337px"
    },
    id: "el3rrzninqty5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 225.09a.42.42 0 0 1-.36-.2.43.43 0 0 1 .15-.57l31.27-18a.41.41 0 0 1 .41.72l-31.26 18a.41.41 0 0 1-.21.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "186.634px 215.678px"
    },
    id: "elsdcnknbaoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36 261.2a.4.4 0 0 1-.36-.2.4.4 0 0 1 .15-.56l84.86-49a.41.41 0 0 1 .56.15.4.4 0 0 1-.15.56l-84.86 49a.39.39 0 0 1-.2.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "159.785px 236.293px"
    },
    id: "el5foxuav0ci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36 266.35a.39.39 0 0 1-.35-.2.41.41 0 0 1 .15-.57l31.26-18a.42.42 0 1 1 .42.72l-31.27 18a.5.5 0 0 1-.21.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.023px 256.922px"
    },
    id: "elvm78r4cgtfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1 245.72a.41.41 0 0 1-.21-.77l17.86-10.31a.42.42 0 0 1 .57.15.42.42 0 0 1-.15.56l-17.87 10.32a.46.46 0 0 1-.2.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "162.024px 240.152px"
    },
    id: "elrcogxrwicdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.37 232.86a.38.38 0 0 1-.35-.21.4.4 0 0 1 .15-.56l26.83-15.5a.41.41 0 0 1 .56.15.4.4 0 0 1-.15.56l-26.85 15.51a.46.46 0 0 1-.19.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "188.79px 224.698px"
    },
    id: "el927rbcgejjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36 271.51a.38.38 0 0 1-.35-.21.4.4 0 0 1 .15-.56l13.4-7.74a.41.41 0 0 1 .41.72l-13.4 7.73a.37.37 0 0 1-.21.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "124.064px 267.229px"
    },
    id: "elwl8kfmwkq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23 261.2a.43.43 0 0 1-.36-.21.42.42 0 0 1 .15-.56l31.27-18.06a.41.41 0 0 1 .41.72l-31.26 18a.42.42 0 0 1-.21.11Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "150.864px 251.758px"
    },
    id: "el2ojl28p9u0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 240.57a.43.43 0 0 1-.36-.21.42.42 0 0 1 .15-.56L202 221.75a.41.41 0 0 1 .56.15.4.4 0 0 1-.15.56l-31.26 18a.42.42 0 0 1-.15.11Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "186.604px 231.133px"
    },
    id: "ela7qevgpwu9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.76 109.94v57.72a4 4 0 0 1-1.81 3.13l-89.33 51.81a1.73 1.73 0 0 1-.31.14c-.85.33-1.49-.15-1.49-1.18v-57.73a3.72 3.72 0 0 1 .53-1.78 3.65 3.65 0 0 1 1.27-1.34L300 108.88c.84-.47 1.54-.23 1.75.54a.77.77 0 0 0 0-.15 2.32 2.32 0 0 1 .07.38c-.07.1-.06.19-.06.29Z",
    style: {
      fill: "#37474f",
      transformOrigin: "255.32px 165.741px"
    },
    id: "elknhc4ind6tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "255.285px 181.62px"
    },
    id: "elooyrx2xtqta",
    className: "animable",
    d: "m213.85 214.34 82.87-47.86v-13.93l-22.46-3.65-15.92 19.43 4.33 4.88-25.58-15.48-23.24 37.74v18.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 125.46c2.46-1.44 4.46-.31 4.45 2.53a9.87 9.87 0 0 1-4.47 7.73c-2.47 1.42-4.46.29-4.45-2.53a9.92 9.92 0 0 1 4.47-7.73Z",
    style: {
      fill: "#455a64",
      transformOrigin: "287.99px 130.584px"
    },
    id: "el62uyqc7j2jx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.65 270.64v43.33a2.9 2.9 0 0 1-1.31 2.26l-48.32 27.88-.22.1c-.62.24-1.08-.11-1.08-.85V300a2.87 2.87 0 0 1 1.3-2.25l48.29-27.85c.6-.34 1.11-.16 1.26.39a.37.37 0 0 0 0-.11 2.56 2.56 0 0 1 0 .27c.07.06.08.12.08.19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "143.185px 307.006px"
    },
    id: "elyn2zl41y0jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.65 270.64v43.33a2.9 2.9 0 0 1-1.31 2.26l-48.32 27.88-.22.1c-.62.24-1.08-.11-1.08-.85V300a2.87 2.87 0 0 1 1.3-2.25l48.29-27.85c.6-.34 1.11-.16 1.26.39a.37.37 0 0 0 0-.11 2.56 2.56 0 0 1 0 .27c.07.06.08.12.08.19Z",
    style: {
      fill: "#fff",
      opacity: 0.65,
      transformOrigin: "143.185px 307.006px"
    },
    className: "animable",
    id: "eliztx8v2etip"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "143.195px 317.105px"
    },
    id: "ell48810myz5r",
    className: "animable",
    d: "M121.39 338.14 165 312.96v-11.31l-9.41-5.58-9.05 13.2 2.72 3.5-16.46-11.87-11.41 22.95v14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92 287.19c1.78-1.07 3.22-.23 3.22 1.87a7.33 7.33 0 0 1-3.23 5.72c-1.78 1.05-3.22.21-3.22-1.88a7.42 7.42 0 0 1 3.23-5.71Z",
    style: {
      fill: "#fff",
      transformOrigin: "147.915px 290.979px"
    },
    id: "el00mdisf91yl5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.72 193.81v43.33a2.92 2.92 0 0 1-1.3 2.26l-48.33 27.88-.22.1c-.62.24-1.08-.11-1.08-.85v-43.38a2.87 2.87 0 0 1 1.3-2.25l48.3-27.85c.6-.34 1.11-.16 1.26.39a.36.36 0 0 0 0-.11 2.56 2.56 0 0 1 0 .27 1.55 1.55 0 0 1 .07.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "276.255px 230.166px"
    },
    id: "elmz8u900s4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.72 193.81v43.33a2.92 2.92 0 0 1-1.3 2.26l-48.33 27.88-.22.1c-.62.24-1.08-.11-1.08-.85v-43.38a2.87 2.87 0 0 1 1.3-2.25l48.3-27.85c.6-.34 1.11-.16 1.26.39a.36.36 0 0 0 0-.11 2.56 2.56 0 0 1 0 .27 1.55 1.55 0 0 1 .07.21Z",
    style: {
      fill: "#fff",
      opacity: 0.65,
      transformOrigin: "276.255px 230.166px"
    },
    className: "animable",
    id: "elmqden1xrny"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "276.275px 240.275px"
    },
    id: "el61glat102gs",
    className: "animable",
    d: "m254.47 261.31 43.61-25.18v-11.31l-9.42-5.58-9.04 13.2 2.71 3.5-16.46-11.87-11.4 22.95v14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 210.36c1.78-1.07 3.22-.23 3.21 1.87A7.33 7.33 0 0 1 281 218c-1.78 1.05-3.22.21-3.21-1.88a7.39 7.39 0 0 1 3.21-5.76Z",
    style: {
      fill: "#fff",
      transformOrigin: "281px 214.174px"
    },
    id: "elc30u9cyfylc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18 232.23v43.33a2.9 2.9 0 0 1-1.31 2.26l-48.28 27.88a1.12 1.12 0 0 1-.22.1c-.62.24-1.08-.11-1.08-.85v-43.38a2.87 2.87 0 0 1 1.3-2.25l48.29-27.85c.6-.34 1.11-.17 1.26.39a.2.2 0 0 0 0-.11.86.86 0 0 1 0 .27 1.48 1.48 0 0 1 .04.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "209.735px 268.585px"
    },
    id: "el0q17qzq2t7cq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18 232.23v43.33a2.9 2.9 0 0 1-1.31 2.26l-48.28 27.88a1.12 1.12 0 0 1-.22.1c-.62.24-1.08-.11-1.08-.85v-43.38a2.87 2.87 0 0 1 1.3-2.25l48.29-27.85c.6-.34 1.11-.17 1.26.39a.2.2 0 0 0 0-.11.86.86 0 0 1 0 .27 1.48 1.48 0 0 1 .04.21Z",
    style: {
      fill: "#fff",
      opacity: 0.65,
      transformOrigin: "209.735px 268.585px"
    },
    className: "animable",
    id: "elik6igpdl23l"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "209.735px 278.695px"
    },
    id: "el92pbb0vgeyq",
    className: "animable",
    d: "m187.93 299.73 43.61-25.18v-11.31l-9.41-5.58-9.05 13.2 2.71 3.5-16.46-11.87-11.4 22.95v14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46 248.78c1.78-1.07 3.22-.23 3.22 1.87a7.38 7.38 0 0 1-3.23 5.72c-1.78 1.05-3.22.21-3.22-1.88a7.38 7.38 0 0 1 3.23-5.71Z",
    style: {
      fill: "#fff",
      transformOrigin: "214.455px 252.569px"
    },
    id: "elk7mq9c8nb3h",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-123",
    className: "animable animator-active",
    style: {
      transformOrigin: "253.44px 240.572px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-window--inject-123",
    className: "animable",
    style: {
      transformOrigin: "253.44px 240.572px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "253.44px 240.572px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.18 405.79-.66-.38a4.21 4.21 0 0 1-1.9-3.3V215.69a4.22 4.22 0 0 1 1.9-3.3l62.89-36.3a4.88 4.88 0 0 0 2.29-3.09l3.47-14a4.89 4.89 0 0 1 2.29-3l49.74-28.72a4.1 4.1 0 0 1 4.12 0l1.18.68a4.11 4.11 0 0 1 1.76 2l2.79 6.93 106.84-61.55a4.26 4.26 0 0 1 3.81 0l.66.38a4.22 4.22 0 0 1 1.9 3.3v185.33a6.31 6.31 0 0 1-2.85 4.94L137 405.79a4.19 4.19 0 0 1-3.82 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "253.44px 240.57px"
    },
    id: "elk5pn1lnz74",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14 405.5c-.44 0-.51-.51-.51-.81V220.48a5.82 5.82 0 0 1 2.6-4.49L374.64 79.5a1.23 1.23 0 0 1 .57-.19c.44 0 .51.51.51.81v184.21a5.82 5.82 0 0 1-2.6 4.49L136.71 405.31a1.13 1.13 0 0 1-.57.19Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "255.675px 242.405px"
    },
    id: "el740q9rvgx6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.14 79.87a1.31 1.31 0 0 1 0 .25v184.21a5.32 5.32 0 0 1-2.32 4L136.44 404.84a.78.78 0 0 1-.23.1.77.77 0 0 1 0-.25V220.48a5.3 5.3 0 0 1 2.32-4L374.91 80l.23-.1m.07-1.11a1.8 1.8 0 0 0-.85.26L138 215.51a6.36 6.36 0 0 0-2.87 5v184.18c0 .86.43 1.36 1.06 1.36a1.72 1.72 0 0 0 .85-.26L373.4 269.3a6.38 6.38 0 0 0 2.86-5V80.12c0-.86-.42-1.36-1.05-1.36Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "255.695px 242.405px"
    },
    id: "elld9m3bvbo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26 79c0-1.21-.85-1.71-1.9-1.1l-107.65 62.18a1.93 1.93 0 0 1-2.76-1l-3.39-8.43a1.93 1.93 0 0 0-2.76-.95l-49.87 28.8a4.82 4.82 0 0 0-2.29 3l-3.47 14a4.86 4.86 0 0 1-2.3 3L138 214.41a6.36 6.36 0 0 0-2.87 5v12.16L376.26 92.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "255.695px 154.605px"
    },
    id: "eliln6v3hgtu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 216.42a5.82 5.82 0 0 0-.94 3v12.16l-4.44-2.58v-13.31a3.93 3.93 0 0 1 .64-2Z",
    style: {
      fill: "#263238",
      transformOrigin: "133.31px 222.635px"
    },
    id: "elfv2rmxkm0y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.54 406a4.25 4.25 0 0 1-3.36-.2l-.66-.39a4.15 4.15 0 0 1-1.9-3.29V229l4.46 2.57v173.12c0 1.03.62 1.55 1.46 1.31Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.58px 317.627px"
    },
    id: "elf9tot9w4hv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.54 406a4.25 4.25 0 0 1-3.36-.2l-.66-.39a4.15 4.15 0 0 1-1.9-3.29V229l4.46 2.57v173.12c0 1.03.62 1.55 1.46 1.31Z",
    style: {
      opacity: 0.1,
      transformOrigin: "133.58px 317.627px"
    },
    className: "animable",
    id: "elrkm4whfpgig"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.57 218.35-4 2.33 1.54-3a.74.74 0 0 0 0-.72c-.12-.14-.32 0-.46.22l-2.18 4.2s0 .1-.06.15a1.66 1.66 0 0 0 0 .22.84.84 0 0 0 0 .18.35.35 0 0 0 .06.09l2.18 1.68a.17.17 0 0 0 .21 0 .68.68 0 0 0 .25-.31.65.65 0 0 0 0-.69l-1.54-1.18 4-2.32a.87.87 0 0 0 .33-.69c0-.12-.15-.26-.33-.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "142.142px 220.32px"
    },
    id: "elip2goenqlsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.94 216.41 4-2.33-1.54-1.18c-.14-.1-.15-.41 0-.69s.32-.41.46-.31l2.18 1.68.06.09a.48.48 0 0 1 0 .18.78.78 0 0 1 0 .22l-.06.16-2.18 4.21a.58.58 0 0 1-.22.24.16.16 0 0 1-.24 0 .72.72 0 0 1 0-.72l1.54-2.95-4 2.32c-.18.11-.33 0-.33-.31a.85.85 0 0 1 .33-.61Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "150.359px 215.3px"
    },
    id: "el9k0z2r6zco4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15 204.8c0-.24-.23-.21-.34.06l-.55 1.34c-.94-.1-2.08.82-2.85 2.45-1 2.11-1 4.61 0 5.57a1.42 1.42 0 0 0 1.81.11 5 5 0 0 0 1.81-2.2.71.71 0 0 0 0-.7c-.13-.12-.34 0-.46.26-.75 1.58-2 2.28-2.71 1.56s-.74-2.58 0-4.16c.53-1.12 1.3-1.78 2-1.82l-.41 1c-.11.27 0 .51.16.4l1.64-1.07a.52.52 0 0 0 .18-.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "159.046px 209.621px"
    },
    id: "elqesqpflpmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.72 137.64 1.47-3.11a.92.92 0 0 0 0-1c-.17-.16-.45 0-.63.37l-1.46 3.1-1.47-1.41c-.18-.17-.46 0-.63.36a1 1 0 0 0 0 1l1.47 1.42-1.47 3.1a1 1 0 0 0 0 1 .23.23 0 0 0 .31 0 .83.83 0 0 0 .32-.38l1.47-3.09 1.46 1.41a.24.24 0 0 0 .32 0 .82.82 0 0 0 .31-.38.92.92 0 0 0 0-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.102px 137.999px"
    },
    id: "elb5y630id156",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.56 87.92a.66.66 0 0 0 .33-.09l5.45-3.14a.67.67 0 0 0-.67-1.16l-5.45 3.14a.67.67 0 0 0 .34 1.25Zm5.11 1.9L366.22 93a.67.67 0 0 0 .34 1.25.66.66 0 0 0 .33-.09l5.45-3.16a.67.67 0 0 0 .24-.92.66.66 0 0 0-.91-.26Zm0-3.15-5.45 3.15a.67.67 0 1 0 .67 1.16l5.45-3.15a.66.66 0 0 0 .24-.91.67.67 0 0 0-.91-.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "369.272px 88.8491px"
    },
    id: "elzl91g5kntpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "256.028px 153.592px"
    },
    className: "animable",
    id: "el73iazfat73p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.57 218.35-4 2.33 1.54-3a.74.74 0 0 0 0-.72c-.12-.14-.32 0-.46.22l-2.18 4.2s0 .1-.06.15a1.66 1.66 0 0 0 0 .22.84.84 0 0 0 0 .18.35.35 0 0 0 .06.09l2.18 1.68a.17.17 0 0 0 .21 0 .68.68 0 0 0 .25-.31.65.65 0 0 0 0-.69l-1.54-1.18 4-2.32a.87.87 0 0 0 .33-.69c0-.12-.15-.26-.33-.16Z",
    style: {
      fill: "#fff",
      transformOrigin: "142.142px 220.32px"
    },
    id: "eln87f6tcoczh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.94 216.41 4-2.33-1.54-1.18c-.14-.1-.15-.41 0-.69s.32-.41.46-.31l2.18 1.68.06.09a.48.48 0 0 1 0 .18.78.78 0 0 1 0 .22l-.06.16-2.18 4.21a.58.58 0 0 1-.22.24.16.16 0 0 1-.24 0 .72.72 0 0 1 0-.72l1.54-2.95-4 2.32c-.18.11-.33 0-.33-.31a.85.85 0 0 1 .33-.61Z",
    style: {
      fill: "#fff",
      transformOrigin: "150.359px 215.3px"
    },
    id: "elu74x5ehne3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15 204.8c0-.24-.23-.21-.34.06l-.55 1.34c-.94-.1-2.08.82-2.85 2.45-1 2.11-1 4.61 0 5.57a1.42 1.42 0 0 0 1.81.11 5 5 0 0 0 1.81-2.2.71.71 0 0 0 0-.7c-.13-.12-.34 0-.46.26-.75 1.58-2 2.28-2.71 1.56s-.74-2.58 0-4.16c.53-1.12 1.3-1.78 2-1.82l-.41 1c-.11.27 0 .51.16.4l1.64-1.07a.52.52 0 0 0 .18-.45Z",
    style: {
      fill: "#fff",
      transformOrigin: "159.046px 209.621px"
    },
    id: "el363o9jpczgw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.72 137.64 1.47-3.11a.92.92 0 0 0 0-1c-.17-.16-.45 0-.63.37l-1.46 3.1-1.47-1.41c-.18-.17-.46 0-.63.36a1 1 0 0 0 0 1l1.47 1.42-1.47 3.1a1 1 0 0 0 0 1 .23.23 0 0 0 .31 0 .83.83 0 0 0 .32-.38l1.47-3.09 1.46 1.41a.24.24 0 0 0 .32 0 .82.82 0 0 0 .31-.38.92.92 0 0 0 0-1Z",
    style: {
      fill: "#fff",
      transformOrigin: "257.102px 137.999px"
    },
    id: "eloivlevw525r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.56 87.92a.66.66 0 0 0 .33-.09l5.45-3.14a.67.67 0 0 0-.67-1.16l-5.45 3.14a.67.67 0 0 0 .34 1.25Zm5.11 1.9L366.22 93a.67.67 0 0 0 .34 1.25.66.66 0 0 0 .33-.09l5.45-3.16a.67.67 0 0 0 .24-.92.66.66 0 0 0-.91-.26Zm0-3.15-5.45 3.15a.67.67 0 1 0 .67 1.16l5.45-3.15a.66.66 0 0 0 .24-.91.67.67 0 0 0-.91-.25Z",
    style: {
      fill: "#fff",
      transformOrigin: "369.272px 88.8491px"
    },
    id: "elaltxiv6yxla",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.46 207.79v-3a5.69 5.69 0 0 1 2.56-4.45L359.58 89.87c1.42-.82 2.57-.16 2.57 1.48v3a5.64 5.64 0 0 1-2.57 4.44L168 209.27c-1.39.82-2.54.15-2.54-1.48Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "263.805px 149.569px"
    },
    id: "elilaytfkdkmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33 99a.42.42 0 0 1-.16 0 .49.49 0 0 1-.28-.56l.18-1.52-.71-.51a.49.49 0 0 1-.2-.42.86.86 0 0 1 .31-.65l1.08-.84.05-.08.49-1.6a.69.69 0 0 1 .55-.52.45.45 0 0 1 .43.26l.41.87.92-.35a.43.43 0 0 1 .49.11.69.69 0 0 1 0 .75l-.79 1.48a.2.2 0 0 0 0 .09l.18 1.34a.81.81 0 0 1-.23.66.49.49 0 0 1-.43.17l-.89-.11-1 1.23a.58.58 0 0 1-.4.2Zm-.52-3.1.71.51a.53.53 0 0 1 .19.52l-.12 1 .65-.82a.53.53 0 0 1 .48-.24l.89.11a.21.21 0 0 0 0-.1l-.19-1.33a.82.82 0 0 1 .1-.48l.69-1.3-.71.27a.43.43 0 0 1-.57-.22l-.32-.68-.43 1.42a.82.82 0 0 1-.27.4l-1.09.84a.19.19 0 0 0-.01.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "357.58px 95.6536px"
    },
    id: "elog50019ag4g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-123",
    className: "animable",
    style: {
      transformOrigin: "255.688px 248.759px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164 258.55 133.48-77c.64-.37 1.15-.11 1.15.58a2.44 2.44 0 0 1-1.15 1.9L164 261c-.64.36-1.15.1-1.15-.58a2.44 2.44 0 0 1 1.15-1.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "230.74px 221.272px"
    },
    id: "elta9k8tqa0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164 258.55 133.48-77c.64-.37 1.15-.11 1.15.58a2.44 2.44 0 0 1-1.15 1.9L164 261c-.64.36-1.15.1-1.15-.58a2.44 2.44 0 0 1 1.15-1.87Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      transformOrigin: "230.74px 221.272px"
    },
    className: "animable",
    id: "elv4w9rry6x5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.44 202.29-45.36 26.19a2.46 2.46 0 0 0-1.15 1.9c0 .69.52 1 1.15.58l45.36-26.18a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.95-1.15-.58Zm88.78-51.1-84.33 48.53a2.47 2.47 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l84.33-48.53a2.46 2.46 0 0 0 1.15-1.91c0-.68-.51-.94-1.15-.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "231.15px 191.089px"
    },
    id: "el3apcqf1c7jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.44 202.29-45.36 26.19a2.46 2.46 0 0 0-1.15 1.9c0 .69.52 1 1.15.58l45.36-26.18a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.95-1.15-.58Zm88.78-51.1-84.33 48.53a2.47 2.47 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l84.33-48.53a2.46 2.46 0 0 0 1.15-1.91c0-.68-.51-.94-1.15-.58Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      transformOrigin: "231.15px 191.089px"
    },
    className: "animable",
    id: "el1dzofchvdgx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.57 367.12 121.16-69.91c.63-.36 1.15-.1 1.15.58a2.48 2.48 0 0 1-1.15 1.91l-121.16 69.91c-.63.37-1.15.11-1.15-.58a2.48 2.48 0 0 1 1.15-1.91Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "237.15px 333.413px"
    },
    id: "eledv1gv1oe27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.5 222.27 79.9-46a2.46 2.46 0 0 0 1.15-1.91c0-.68-.51-.94-1.15-.58l-79.9 46a2.46 2.46 0 0 0-1.15 1.91c0 .68.51.94 1.15.58Zm106.05-48.58-88.81 50.87a2.46 2.46 0 0 0-1.15 1.91c0 .69.51.95 1.15.58l88.81-50.87a2.47 2.47 0 0 0 1.14-1.91c0-.69-.51-.95-1.14-.58Zm-133.47 64.42 23-13.27a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-1-1.15-.58l-23 13.27a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58Zm43.51-19.27c0 .69.51.95 1.15.58l88.81-50.87a2.47 2.47 0 0 0 1.14-1.91c0-.68-.51-.94-1.14-.58l-88.81 50.87a2.46 2.46 0 0 0-1.15 1.91Zm-43.51 26.38 13.79-7.94a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-1-1.15-.58l-13.79 7.94a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58Zm40.21-25.72-22.73 13.19a2.46 2.46 0 0 0-1.15 1.9c0 .69.52.95 1.15.58L204.29 222a2.46 2.46 0 0 0 1.14-1.91c0-.69-.51-.95-1.14-.59Zm0 7.63L164 250.23a2.46 2.46 0 0 0-1.15 1.91c0 .69.51 1 1.15.58l40.25-23.1a2.47 2.47 0 0 0 1.14-1.91c.04-.71-.47-.94-1.1-.58Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "230.77px 209.404px"
    },
    id: "el6za4dmetej6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.44 342-32.82 19a2.46 2.46 0 0 0-1.15 1.91c0 .69.51.95 1.15.58l32.82-18.93a2.48 2.48 0 0 0 1.15-1.91c0-.73-.52-.99-1.15-.65Zm88.78-51.12-84.33 48.46a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l84.33-48.46a2.46 2.46 0 0 0 1.15-1.91c0-.65-.51-.91-1.15-.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "237.42px 327.203px"
    },
    id: "elb5pklhc39re",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.44 342-32.82 19a2.46 2.46 0 0 0-1.15 1.91c0 .69.51.95 1.15.58l32.82-18.93a2.48 2.48 0 0 0 1.15-1.91c0-.73-.52-.99-1.15-.65Zm88.78-51.12-84.33 48.46a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l84.33-48.46a2.46 2.46 0 0 0 1.15-1.91c0-.65-.51-.91-1.15-.55Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      transformOrigin: "237.42px 327.203px"
    },
    className: "animable",
    id: "el0zzxw9r6v6to"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.22 273.84-122 70.24a2.46 2.46 0 0 0-1.12 1.92c0 .68.51.94 1.15.58l122-70.24a2.44 2.44 0 0 0 1.15-1.91c-.03-.69-.54-.95-1.18-.59Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "237.25px 310.21px"
    },
    id: "elzhl812co9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.58 324.11 107.64-62a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-.95-1.15-.58l-107.64 62a2.46 2.46 0 0 0-1.15 1.9c0 .7.57.96 1.15.59Zm107.64-57.42-107.64 62a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l107.64-62a2.46 2.46 0 0 0 1.15-1.91c0-.68-.51-.94-1.15-.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "244.4px 295.397px"
    },
    id: "el7rlh95brkoy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.58 324.11 107.64-62a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-.95-1.15-.58l-107.64 62a2.46 2.46 0 0 0-1.15 1.9c0 .7.57.96 1.15.59Zm107.64-57.42-107.64 62a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l107.64-62a2.46 2.46 0 0 0 1.15-1.91c0-.68-.51-.94-1.15-.58Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      transformOrigin: "244.4px 295.397px"
    },
    className: "animable",
    id: "elhyes0n3w3k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 310.75 122.18-70.4a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-.95-1.15-.58L176 308.26a2.47 2.47 0 0 0-1.14 1.91c.04.69.55.95 1.14.58Zm122.18-66.64L176 314.75a2.45 2.45 0 0 0-1.14 1.9c0 .69.51 1 1.14.59l122.22-70.64a2.44 2.44 0 0 0 1.15-1.9c0-.7-.51-.95-1.15-.59Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "237.115px 277.558px"
    },
    id: "elnwbebplhvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207 262 91.22-52.73a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-1-1.15-.58L207 259.51a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58Zm-31 10.76 122.18-70.63a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-.95-1.15-.58L176 270.27a2.47 2.47 0 0 0-1.14 1.91c.04.69.55.95 1.14.58Zm122.18-58.61L176 284.57a2.47 2.47 0 0 0-1.14 1.91c0 .68.51.94 1.14.58l122.18-70.42a2.46 2.46 0 0 0 1.15-1.91c.04-.73-.47-.95-1.11-.58Zm0 7.12-59.84 34.49a2.46 2.46 0 0 0-1.15 1.9c0 .69.52.95 1.15.58l59.84-34.48a2.46 2.46 0 0 0 1.15-1.91c.04-.69-.47-.95-1.11-.58Zm0 7.12-59.84 34.49a2.46 2.46 0 0 0-1.15 1.9c0 .69.52 1 1.15.58l59.84-34.48a2.46 2.46 0 0 0 1.15-1.91c.04-.69-.47-.97-1.11-.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "237.115px 243.347px"
    },
    id: "el00ve1ijo8mzu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207 262 91.22-52.73a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-1-1.15-.58L207 259.51a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58Zm-31 10.76 122.18-70.63a2.46 2.46 0 0 0 1.15-1.91c0-.69-.51-.95-1.15-.58L176 270.27a2.47 2.47 0 0 0-1.14 1.91c.04.69.55.95 1.14.58Zm122.18-58.61L176 284.57a2.47 2.47 0 0 0-1.14 1.91c0 .68.51.94 1.14.58l122.18-70.42a2.46 2.46 0 0 0 1.15-1.91c.04-.73-.47-.95-1.11-.58Zm0 7.12-59.84 34.49a2.46 2.46 0 0 0-1.15 1.9c0 .69.52.95 1.15.58l59.84-34.48a2.46 2.46 0 0 0 1.15-1.91c.04-.69-.47-.95-1.11-.58Zm0 7.12-59.84 34.49a2.46 2.46 0 0 0-1.15 1.9c0 .69.52 1 1.15.58l59.84-34.48a2.46 2.46 0 0 0 1.15-1.91c.04-.69-.47-.97-1.11-.58Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      transformOrigin: "237.115px 243.347px"
    },
    className: "animable",
    id: "el5mhh389u8im"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154 326.11-6.25 3.61a2.5 2.5 0 0 0-1.14 2V334c0 .73.51 1 1.14.66L154 331a2.51 2.51 0 0 0 1.13-2v-2.3c0-.65-.51-.95-1.13-.59Zm0 18.29-6.25 3.6a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.65l6.25-3.6a2.55 2.55 0 0 0 1.13-2v-2.3c0-.72-.51-1.05-1.13-.65Zm0-9.14-6.25 3.6a2.53 2.53 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.65l6.25-3.61a2.51 2.51 0 0 0 1.13-2v-2.3c0-.71-.51-1.01-1.13-.64Zm0 18.28-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.65l6.25-3.6a2.55 2.55 0 0 0 1.13-2v-2.3c0-.73-.51-1.02-1.13-.66Zm0 27.06-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .73.51 1 1.14.66l6.25-3.61a2.52 2.52 0 0 0 1.13-2v-2.29c0-.74-.51-1.03-1.13-.67Zm0-72.41-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.29c0 .73.51 1 1.14.66l6.25-3.61a2.51 2.51 0 0 0 1.13-2v-2.3c0-.72-.51-1.01-1.13-.65Zm0 63.27-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.66l6.25-3.61a2.52 2.52 0 0 0 1.13-2v-2.3c0-.73-.51-1.02-1.13-.66Zm0-81.55-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.66l6.25-3.61a2.52 2.52 0 0 0 1.13-2v-2.29c0-.74-.51-1.03-1.13-.67Zm0-9.14-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.66l6.25-3.61a2.52 2.52 0 0 0 1.13-2v-2.3c0-.73-.51-1.02-1.13-.66Zm0 18.28-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.29c0 .73.51 1 1.14.66L154 304a2.52 2.52 0 0 0 1.13-2v-2.29c0-.71-.51-1.02-1.13-.66Zm0-63.63-6.25 3.58a2.5 2.5 0 0 0-1.14 2v2.29c0 .73.51 1 1.14.66l6.25-3.61a2.51 2.51 0 0 0 1.13-2v-2.3c0-.69-.51-.98-1.13-.62Zm0 9.14-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.65l6.25-3.61a2.51 2.51 0 0 0 1.13-2v-2.3c0-.71-.51-1.01-1.13-.65Zm0 9.15-6.25 3.6a2.53 2.53 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.65l6.25-3.61a2.51 2.51 0 0 0 1.13-2v-2.3c0-.71-.51-1.01-1.13-.64Zm0 9.14-6.25 3.61a2.5 2.5 0 0 0-1.14 2v2.3c0 .72.51 1 1.14.65l6.25-3.6a2.55 2.55 0 0 0 1.13-2v-2.3c0-.73-.51-1.02-1.13-.66Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "150.87px 312.29px"
    },
    id: "elfldcmn1v22i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.64 311.88-5.32 3.06a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l5.32-3.06a2.46 2.46 0 0 0 1.15-1.9c0-.69-.52-.95-1.15-.59Zm0 6.44-5.32 3.06a2.46 2.46 0 0 0-1.15 1.9c0 .69.52 1 1.15.59l5.32-3.06a2.47 2.47 0 0 0 1.15-1.91c0-.68-.52-.9-1.15-.58Zm0 46.62-5.32 3.06a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.7-.52-.96-1.15-.59Zm0 6.44-5.32 3.05a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.96-1.15-.58Zm0-37.75-5.32 3.06a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l5.32-3.06a2.46 2.46 0 0 0 1.15-1.9c0-.69-.52-.95-1.15-.59Zm0 7.13-5.32 3.05a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l5.32-3.06a2.46 2.46 0 0 0 1.15-1.9c0-.69-.52-.95-1.15-.58Zm0 7.12-5.32 3.05a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.95-1.15-.58Zm-5.32-69.36 5.32-3a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.95-1.15-.58l-5.32 3a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58Zm5.32 9.77-5.32 3a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.64-.52-.9-1.15-.53Zm0 7.12-5.32 3a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.64-.52-.94-1.15-.53Zm0 7.12-5.32 3.06a2.46 2.46 0 0 0-1.15 1.9c0 .69.52.95 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.68-.52-.94-1.15-.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "166.98px 324.986px"
    },
    id: "el2mrsehi58nn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.64 311.88-5.32 3.06a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l5.32-3.06a2.46 2.46 0 0 0 1.15-1.9c0-.69-.52-.95-1.15-.59Zm0 6.44-5.32 3.06a2.46 2.46 0 0 0-1.15 1.9c0 .69.52 1 1.15.59l5.32-3.06a2.47 2.47 0 0 0 1.15-1.91c0-.68-.52-.9-1.15-.58Zm0 46.62-5.32 3.06a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.7-.52-.96-1.15-.59Zm0 6.44-5.32 3.05a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.96-1.15-.58Zm0-37.75-5.32 3.06a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l5.32-3.06a2.46 2.46 0 0 0 1.15-1.9c0-.69-.52-.95-1.15-.59Zm0 7.13-5.32 3.05a2.48 2.48 0 0 0-1.15 1.91c0 .68.52.94 1.15.58l5.32-3.06a2.46 2.46 0 0 0 1.15-1.9c0-.69-.52-.95-1.15-.58Zm0 7.12-5.32 3.05a2.48 2.48 0 0 0-1.15 1.91c0 .69.52 1 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.95-1.15-.58Zm-5.32-69.36 5.32-3a2.48 2.48 0 0 0 1.15-1.91c0-.69-.52-.95-1.15-.58l-5.32 3a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58Zm5.32 9.77-5.32 3a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.64-.52-.9-1.15-.53Zm0 7.12-5.32 3a2.48 2.48 0 0 0-1.15 1.91c0 .69.52.95 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.64-.52-.94-1.15-.53Zm0 7.12-5.32 3.06a2.46 2.46 0 0 0-1.15 1.9c0 .69.52.95 1.15.58l5.32-3.05a2.48 2.48 0 0 0 1.15-1.91c0-.68-.52-.94-1.15-.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "166.98px 324.986px"
    },
    className: "animable",
    id: "elecs47pf6arm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73 291.47a2 2 0 0 1-1-.27 2.6 2.6 0 0 1-1.13-2.41v-72.2a7.53 7.53 0 0 1 3.41-5.9L360.92 183a2.32 2.32 0 0 1 3.78 2.18v72.22a7.55 7.55 0 0 1-3.41 5.9L313.35 291a3.24 3.24 0 0 1-1.62.47Zm50.81-108.2a2.57 2.57 0 0 0-1.25.39l-47.94 27.68a6.7 6.7 0 0 0-3 5.25v72.2a1.9 1.9 0 0 0 .76 1.76 1.88 1.88 0 0 0 1.9-.22l47.94-27.68a6.72 6.72 0 0 0 3-5.25v-72.21a1.92 1.92 0 0 0-.76-1.76 1.28 1.28 0 0 0-.65-.16Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "337.162px 236.962px"
    },
    id: "eluy0wqfdw5gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 238.21-4.41 2.55a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 241.252px"
    },
    id: "el8algrmgyqq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 238.21-4.41 2.55a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 241.252px"
    },
    className: "animable",
    id: "eljwgs5v3sy7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 192.87-4.41 2.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.56a3.48 3.48 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 195.917px"
    },
    id: "elkgc5cs83boq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 192.87-4.41 2.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.56a3.48 3.48 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 195.917px"
    },
    className: "animable",
    id: "elnm91s6d9hcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 205.5-4.45 2.55a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c.04-.98-.69-1.33-1.59-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 208.548px"
    },
    id: "elenjglf64fat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 205.5-4.45 2.55a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c.04-.98-.69-1.33-1.59-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 208.548px"
    },
    className: "animable",
    id: "els104huetto"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.45 214.54 346 217.1a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.56a3.48 3.48 0 0 0 1.63-2.7c.04-.98-.69-1.37-1.59-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 217.583px"
    },
    id: "elbkdkttd93u4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.45 214.54 346 217.1a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.56a3.48 3.48 0 0 0 1.63-2.7c.04-.98-.69-1.37-1.59-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 217.583px"
    },
    className: "animable",
    id: "elpjj0ixtopy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 220.07-4.41 2.55a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 223.112px"
    },
    id: "ely3nwj01dwee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 220.07-4.41 2.55a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 223.112px"
    },
    className: "animable",
    id: "ell7h2r7yic1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 232.7-4.45 2.56a3.48 3.48 0 0 0-1.63 2.7c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c.04-.98-.69-1.35-1.59-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 235.743px"
    },
    id: "elf5btj8kvv2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 232.7-4.45 2.56a3.48 3.48 0 0 0-1.63 2.7c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c.04-.98-.69-1.35-1.59-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 235.743px"
    },
    className: "animable",
    id: "elvxbjm9jn1h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 199.86-26.95 15.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l26.95-15.56a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 209.407px"
    },
    id: "eln3aiyi8c08m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 199.86-26.95 15.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l26.95-15.56a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 209.407px"
    },
    className: "animable",
    id: "elx4t9pbuxnmp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 245.19-26.95 15.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l26.95-15.56a3.49 3.49 0 0 0 1.63-2.72c0-1-.73-1.33-1.63-.81Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 254.733px"
    },
    id: "elcn04b42dju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 245.19-26.95 15.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l26.95-15.56a3.49 3.49 0 0 0 1.63-2.72c0-1-.73-1.33-1.63-.81Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 254.733px"
    },
    className: "animable",
    id: "el520qz8e9vrh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 212.48-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.31-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.995px 220.257px"
    },
    id: "elkpax0gyu22d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 212.48-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.31-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "327.995px 220.257px"
    },
    className: "animable",
    id: "elfz04nek7evq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 221.55-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.37-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.995px 229.311px"
    },
    id: "elutzwrd4c2dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 221.55-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.37-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "327.995px 229.311px"
    },
    className: "animable",
    id: "elocnon40k1td"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 227.05-26.95 15.57a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l26.95-15.57a3.48 3.48 0 0 0 1.63-2.7c0-.98-.73-1.34-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 236.604px"
    },
    id: "el9ifj6m8wnoa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 227.05-26.95 15.57a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l26.95-15.57a3.48 3.48 0 0 0 1.63-2.7c0-.98-.73-1.34-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 236.604px"
    },
    className: "animable",
    id: "elhtrp06n7f8o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 239.68-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.995px 247.448px"
    },
    id: "el19heq5l57ba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 239.68-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "327.995px 247.448px"
    },
    className: "animable",
    id: "el1kf7klhdsju"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 256.44-4.41 2.56a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 259.488px"
    },
    id: "elenlr3jk5pns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 256.44-4.41 2.56a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 259.488px"
    },
    className: "animable",
    id: "elig2bnnqc66a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 250.93-4.45 2.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.56a3.49 3.49 0 0 0 1.63-2.7c.04-.98-.69-1.35-1.59-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 253.977px"
    },
    id: "elkrxzdv7ovp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 250.93-4.45 2.56a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l4.41-2.56a3.49 3.49 0 0 0 1.63-2.7c.04-.98-.69-1.35-1.59-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 253.977px"
    },
    className: "animable",
    id: "elaeu1dkf1vbg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57 263.42 317.62 279a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82L344.57 267a3.49 3.49 0 0 0 1.63-2.71c0-1.02-.73-1.39-1.63-.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 272.979px"
    },
    id: "eljgdif9lrua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57 263.42 317.62 279a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82L344.57 267a3.49 3.49 0 0 0 1.63-2.71c0-1.02-.73-1.39-1.63-.87Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 272.979px"
    },
    className: "animable",
    id: "el6o1h27rrheo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 257.92-20.75 12a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.51 3.51 0 0 0 1.63-2.71c0-.98-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.995px 265.687px"
    },
    id: "el47bgj3qhgqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 257.92-20.75 12a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12a3.51 3.51 0 0 0 1.63-2.71c0-.98-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "327.995px 265.687px"
    },
    className: "animable",
    id: "elg0qvwe8ucki"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73 200.36a2 2 0 0 1-1-.27 2.62 2.62 0 0 1-1.13-2.41v-55.35a7.56 7.56 0 0 1 3.41-5.91l47.94-27.67a2.32 2.32 0 0 1 3.78 2.18v55.35a7.56 7.56 0 0 1-3.41 5.91l-47.94 27.67a3.26 3.26 0 0 1-1.65.5ZM362.54 109a2.68 2.68 0 0 0-1.25.39l-47.94 27.68a6.72 6.72 0 0 0-3 5.26v55.35a1.6 1.6 0 0 0 2.66 1.54l47.94-27.68a6.74 6.74 0 0 0 3-5.26v-55.35a1.91 1.91 0 0 0-.76-1.76 1.29 1.29 0 0 0-.65-.17Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "337.177px 154.282px"
    },
    id: "elyyrtp7jdm5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 163.94-4.41 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 166.983px"
    },
    id: "elg3jh4llirow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 163.94-4.41 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 166.983px"
    },
    className: "animable",
    id: "elf4trrjhzlw6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 118.61-4.41 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 121.653px"
    },
    id: "elp70xyjdq9qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 118.61-4.41 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 121.653px"
    },
    className: "animable",
    id: "elyx9ellvrbia"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 131.24-4.45 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c.04-.97-.69-1.34-1.59-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 134.283px"
    },
    id: "elxegnejm09tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 131.24-4.45 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c.04-.97-.69-1.34-1.59-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 134.283px"
    },
    className: "animable",
    id: "elaekadrb9bti"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 140.28-4.45 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c.04-.97-.69-1.34-1.59-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 143.323px"
    },
    id: "el1supxgzkch8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.45 140.28-4.45 2.55a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c.04-.97-.69-1.34-1.59-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 143.323px"
    },
    className: "animable",
    id: "elikri3ofugdg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 145.8-4.41 2.55a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.445px 148.843px"
    },
    id: "el1fa1np91ysri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.65 145.8-4.41 2.55a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "354.445px 148.843px"
    },
    className: "animable",
    id: "elwq0pmi2p8zp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.45 158.44 346 161a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c.04-.98-.69-1.35-1.59-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "348.206px 161.488px"
    },
    id: "el9nmf9d3l7an",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.45 158.44 346 161a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l4.41-2.55a3.49 3.49 0 0 0 1.63-2.71c.04-.98-.69-1.35-1.59-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "348.206px 161.488px"
    },
    className: "animable",
    id: "elhiwyznzxzeu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 125.59-26.95 15.56a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l26.95-15.56a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 135.138px"
    },
    id: "el6ywh5p13t0y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 125.59-26.95 15.56a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l26.95-15.56a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 135.138px"
    },
    className: "animable",
    id: "el1yrehfm7fll"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 170.92-26.95 15.56a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l26.95-15.56a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 180.468px"
    },
    id: "ela2esud4072d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 170.92-26.95 15.56a3.51 3.51 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l26.95-15.56a3.49 3.49 0 0 0 1.63-2.7c0-.98-.73-1.35-1.63-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 180.468px"
    },
    className: "animable",
    id: "elrest5283e0h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 138.22-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12A3.49 3.49 0 0 0 340 139c0-.93-.73-1.3-1.63-.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.995px 145.987px"
    },
    id: "elwhy70xfzxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 138.22-20.75 12a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l20.75-12A3.49 3.49 0 0 0 340 139c0-.93-.73-1.3-1.63-.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "327.995px 145.987px"
    },
    className: "animable",
    id: "el1r69z56zjii"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 147.28-20.75 12A3.49 3.49 0 0 0 316 162c0 1 .73 1.35 1.63.83l20.75-12a3.49 3.49 0 0 0 1.63-2.7c-.01-1-.74-1.37-1.64-.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "328.005px 155.057px"
    },
    id: "el4pg28pv7lna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 147.28-20.75 12A3.49 3.49 0 0 0 316 162c0 1 .73 1.35 1.63.83l20.75-12a3.49 3.49 0 0 0 1.63-2.7c-.01-1-.74-1.37-1.64-.85Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "328.005px 155.057px"
    },
    className: "animable",
    id: "elal8phq9zkfl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 152.79-26.95 15.56a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l26.95-15.56a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.095px 162.338px"
    },
    id: "el5xm2ooxllzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.57 152.79-26.95 15.56a3.49 3.49 0 0 0-1.63 2.71c0 1 .73 1.34 1.63.82l26.95-15.56a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "331.095px 162.338px"
    },
    className: "animable",
    id: "elcdvw0bf495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 165.42-20.75 12a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l20.75-12a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.995px 173.187px"
    },
    id: "elnynhj63zoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.37 165.42-20.75 12a3.49 3.49 0 0 0-1.63 2.7c0 1 .73 1.35 1.63.83l20.75-12a3.49 3.49 0 0 0 1.63-2.71c0-.97-.73-1.34-1.63-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "327.995px 173.187px"
    },
    className: "animable",
    id: "ell25xifidnmc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-123",
    className: "animable",
    style: {
      transformOrigin: "97.9109px 72.7325px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-123",
    className: "animable",
    style: {
      transformOrigin: "97.9109px 72.7325px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.57 61.66-5.68-3.26a.6.6 0 0 0-.58 0l-3.87 1.74a1.64 1.64 0 0 1 .11-.94l4.48-9a1 1 0 0 0-.4-1.31l-4.86-2.81-5.67-3.25a1 1 0 0 0-1.33.32l-5.58 8.38a1.67 1.67 0 0 1-.73.56L78 47.84a.62.62 0 0 0-.28-.51l-5.69-3.26a.62.62 0 0 0-.61 0l-7.54 4.36a2 2 0 0 0-.9 1.4l-.75 8.39a2.84 2.84 0 0 1-.79 1.57 45.3 45.3 0 0 0-4.19 4.43 1.41 1.41 0 0 1-1.48.42L51 63a1.19 1.19 0 0 0-1.36.51l-5.54 9.6a1.19 1.19 0 0 0 .24 1.43l3.88 3.35a1.43 1.43 0 0 1 .38 1.49 44.27 44.27 0 0 0-1.74 5.85 2.85 2.85 0 0 1-1 1.46L39 91.54a2 2 0 0 0-.81 1.46v8.71a.64.64 0 0 0 .27.56l5.68 3.25a.6.6 0 0 0 .58 0l3.88-1.74a1.73 1.73 0 0 1-.12.94l-4.47 9a1 1 0 0 0 .39 1.31l6.82 3.97 3.7 2.14a1 1 0 0 0 1.33-.32l5.58-8.38a1.67 1.67 0 0 1 .73-.56l.43 4.25a.65.65 0 0 0 .29.51l5.72 3.24a.61.61 0 0 0 .62 0l7.54-4.36a2 2 0 0 0 .9-1.4l.76-8.4a2.77 2.77 0 0 1 .78-1.56 44.31 44.31 0 0 0 4.19-4.44 1.44 1.44 0 0 1 1.48-.42l4.84 1.69a1.17 1.17 0 0 0 1.36-.5L97 90.84a1.19 1.19 0 0 0-.24-1.43l-3.88-3.35a1.43 1.43 0 0 1-.38-1.49 45.89 45.89 0 0 0 1.75-5.85 2.83 2.83 0 0 1 1-1.46l6.89-4.85a2 2 0 0 0 .77-1.48v-8.71a.61.61 0 0 0-.34-.56ZM60.61 91c0-8.13 5.71-18 12.74-22.07 2.75-1.59 5.3-2 7.38-1.54 1.07 1.5 1.65 3.78 1.65 6.76 0 8.12-5.7 18-12.74 22.06-2.75 1.59-5.09 2.1-6.92 1.67A10.43 10.43 0 0 1 60.61 91Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "70.5495px 81.985px"
    },
    id: "el1tt7cpupigc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.57 61.66-5.68-3.26a.6.6 0 0 0-.58 0l-3.87 1.74a1.64 1.64 0 0 1 .11-.94l4.48-9a1 1 0 0 0-.4-1.31l-4.86-2.81-5.67-3.25a1 1 0 0 0-1.33.32l-5.58 8.38a1.67 1.67 0 0 1-.73.56L78 47.84a.62.62 0 0 0-.28-.51l-5.69-3.26a.62.62 0 0 0-.61 0l-7.54 4.36a2 2 0 0 0-.9 1.4l-.75 8.39a2.84 2.84 0 0 1-.79 1.57 45.3 45.3 0 0 0-4.19 4.43 1.41 1.41 0 0 1-1.48.42L51 63a1.19 1.19 0 0 0-1.36.51l-5.54 9.6a1.19 1.19 0 0 0 .24 1.43l3.88 3.35a1.43 1.43 0 0 1 .38 1.49 44.27 44.27 0 0 0-1.74 5.85 2.85 2.85 0 0 1-1 1.46L39 91.54a2 2 0 0 0-.81 1.46v8.71a.64.64 0 0 0 .27.56l5.68 3.25a.6.6 0 0 0 .58 0l3.88-1.74a1.73 1.73 0 0 1-.12.94l-4.47 9a1 1 0 0 0 .39 1.31l6.82 3.97 3.7 2.14a1 1 0 0 0 1.33-.32l5.58-8.38a1.67 1.67 0 0 1 .73-.56l.43 4.25a.65.65 0 0 0 .29.51l5.72 3.24a.61.61 0 0 0 .62 0l7.54-4.36a2 2 0 0 0 .9-1.4l.76-8.4a2.77 2.77 0 0 1 .78-1.56 44.31 44.31 0 0 0 4.19-4.44 1.44 1.44 0 0 1 1.48-.42l4.84 1.69a1.17 1.17 0 0 0 1.36-.5L97 90.84a1.19 1.19 0 0 0-.24-1.43l-3.88-3.35a1.43 1.43 0 0 1-.38-1.49 45.89 45.89 0 0 0 1.75-5.85 2.83 2.83 0 0 1 1-1.46l6.89-4.85a2 2 0 0 0 .77-1.48v-8.71a.61.61 0 0 0-.34-.56ZM60.61 91c0-8.13 5.71-18 12.74-22.07 2.75-1.59 5.3-2 7.38-1.54 1.07 1.5 1.65 3.78 1.65 6.76 0 8.12-5.7 18-12.74 22.06-2.75 1.59-5.09 2.1-6.92 1.67A10.43 10.43 0 0 1 60.61 91Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "70.5495px 81.985px"
    },
    className: "animable",
    id: "el2i7l1od7k6r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.55 103a.79.79 0 0 0-1.12-.52l-2.82 1.27a1.77 1.77 0 0 1-.13 1l-4.47 9a1 1 0 0 0 .39 1.31l6.82 3.94-1.15-.67a1 1 0 0 1-.4-1.31l4.48-9a1.87 1.87 0 0 0-.1-1.63 15.07 15.07 0 0 1-1.5-3.39Zm16.35 16.84a.73.73 0 0 1-.23-.48l-.73-7.36a.8.8 0 0 0-1-.71 15.54 15.54 0 0 1-3.63.37 1.77 1.77 0 0 0-.73.15l.43 4.26a.61.61 0 0 0 .29.51Z",
    style: {
      opacity: 0.1,
      transformOrigin: "56.4023px 111.119px"
    },
    className: "animable",
    id: "eld0lgm0lmjq7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09 76.25c0 8.12-5.7 18-12.74 22.06-4.45 2.57-8.36 2.2-10.64-.47 1.83.44 4.17-.08 6.93-1.67 7-4.06 12.74-13.94 12.74-22.06 0-3-.57-5.26-1.64-6.76 3.26.79 5.35 3.95 5.35 8.9Z",
    style: {
      opacity: 0.1,
      transformOrigin: "74.4px 83.7013px"
    },
    className: "animable",
    id: "elxaaqb9fotmb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1 42.83a1 1 0 0 0-1.33.32l-5.58 8.38a1.59 1.59 0 0 1-.37.36l5.68 3.26a1.45 1.45 0 0 0 .37-.37l5.57-8.38a1 1 0 0 1 1.22-.4ZM96.89 58.4a.65.65 0 0 0-.58 0l-3.88 1.76a2.1 2.1 0 0 0 .23.68A14.74 14.74 0 0 1 94.09 64a.58.58 0 0 1 .06.17 1 1 0 0 0 .2.34l.1.09a.59.59 0 0 0 .22.12.71.71 0 0 0 .41 0 .67.67 0 0 0 .19 0l6.71-3a.58.58 0 0 1 .17-.06.45.45 0 0 1 .23 0 .4.4 0 0 1 .19.07ZM72.06 44.07a.62.62 0 0 0-.61 0l-7.54 4.36a1.9 1.9 0 0 0-.75.91l5.66 3.25a2 2 0 0 1 .76-.91l7.54-4.36a.65.65 0 0 1 .58-.07ZM46.38 86.12a2.44 2.44 0 0 1-.53.57L39 91.53a1.84 1.84 0 0 0-.46.53l5.66 3.25a1.57 1.57 0 0 1 .46-.52l6.89-4.85a2.42 2.42 0 0 0 .54-.56ZM50.57 63a1.17 1.17 0 0 0-1 .56l-5.54 9.6a1.13 1.13 0 0 0-.13.7l5.67 3.26a1.11 1.11 0 0 1 .13-.71l5.54-9.6a1.19 1.19 0 0 1 .9-.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "70.555px 69.0046px"
    },
    id: "el8xfdr1ogkkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1 42.83a1 1 0 0 0-1.33.32l-5.58 8.38a1.59 1.59 0 0 1-.37.36l5.68 3.26a1.45 1.45 0 0 0 .37-.37l5.57-8.38a1 1 0 0 1 1.22-.4ZM96.89 58.4a.65.65 0 0 0-.58 0l-3.88 1.76a2.1 2.1 0 0 0 .23.68A14.74 14.74 0 0 1 94.09 64a.58.58 0 0 1 .06.17 1 1 0 0 0 .2.34l.1.09a.59.59 0 0 0 .22.12.71.71 0 0 0 .41 0 .67.67 0 0 0 .19 0l6.71-3a.58.58 0 0 1 .17-.06.45.45 0 0 1 .23 0 .4.4 0 0 1 .19.07ZM72.06 44.07a.62.62 0 0 0-.61 0l-7.54 4.36a1.9 1.9 0 0 0-.75.91l5.66 3.25a2 2 0 0 1 .76-.91l7.54-4.36a.65.65 0 0 1 .58-.07ZM46.38 86.12a2.44 2.44 0 0 1-.53.57L39 91.53a1.84 1.84 0 0 0-.46.53l5.66 3.25a1.57 1.57 0 0 1 .46-.52l6.89-4.85a2.42 2.42 0 0 0 .54-.56ZM50.57 63a1.17 1.17 0 0 0-1 .56l-5.54 9.6a1.13 1.13 0 0 0-.13.7l5.67 3.26a1.11 1.11 0 0 1 .13-.71l5.54-9.6a1.19 1.19 0 0 1 .9-.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "70.555px 69.0046px"
    },
    className: "animable",
    id: "elxg6j8ganapq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.84 70.93v-8.71a.56.56 0 0 0-.86-.55l-6.71 3a.79.79 0 0 1-1.12-.51 14.51 14.51 0 0 0-1.5-3.33 1.87 1.87 0 0 1-.1-1.63l4.48-9a1 1 0 0 0-.4-1.31l-4.86-2.81a1 1 0 0 0-1.33.32l-5.58 8.38a1.85 1.85 0 0 1-1.46.73 15 15 0 0 0-3.63.37.8.8 0 0 1-1-.71L78 47.84a.56.56 0 0 0-.91-.46l-7.54 4.35a2 2 0 0 0-.9 1.41l-.75 8.39a2.85 2.85 0 0 1-.79 1.56A45.42 45.42 0 0 0 63 67.53a1.44 1.44 0 0 1-1.48.42l-4.84-1.69a1.18 1.18 0 0 0-1.36.5l-5.54 9.6a1.19 1.19 0 0 0 .22 1.43l3.88 3.35a1.43 1.43 0 0 1 .38 1.49 44.27 44.27 0 0 0-1.74 5.85 2.81 2.81 0 0 1-1 1.46l-6.89 4.85a2 2 0 0 0-.77 1.48V105a.56.56 0 0 0 .86.55l6.71-3a.79.79 0 0 1 1.12.52 14.63 14.63 0 0 0 1.5 3.32 1.87 1.87 0 0 1 .1 1.63l-4.47 9a1 1 0 0 0 .39 1.31l4.86 2.81a1 1 0 0 0 1.33-.32l5.58-8.38a1.88 1.88 0 0 1 1.46-.73 15.46 15.46 0 0 0 3.63-.36.8.8 0 0 1 1 .71l.73 7.32a.56.56 0 0 0 .91.47l7.54-4.36a2 2 0 0 0 .9-1.4l.76-8.4a2.77 2.77 0 0 1 .78-1.56 44.31 44.31 0 0 0 4.19-4.44 1.44 1.44 0 0 1 1.48-.42l4.84 1.69a1.17 1.17 0 0 0 1.36-.5L97 90.84a1.19 1.19 0 0 0-.24-1.43l-3.88-3.35a1.43 1.43 0 0 1-.38-1.49 45.89 45.89 0 0 0 1.75-5.85 2.83 2.83 0 0 1 1-1.46l6.89-4.85a2 2 0 0 0 .7-1.48ZM73.35 98.31c-7 4.06-12.74.77-12.74-7.35s5.71-18 12.74-22.07 12.74-.77 12.74 7.36-5.7 18-12.74 22.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "73.35px 83.61px"
    },
    id: "elinyvi3zunw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "73.3839px 83.6045px"
    },
    className: "animable",
    id: "el48bscrn9m4j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.84 70.93v-8.71a.56.56 0 0 0-.86-.55l-6.71 3a.79.79 0 0 1-1.12-.51 14.51 14.51 0 0 0-1.5-3.33 1.87 1.87 0 0 1-.1-1.63l4.48-9a1 1 0 0 0-.4-1.31l-4.86-2.81a1 1 0 0 0-1.33.32l-5.58 8.38a1.85 1.85 0 0 1-1.46.73 15 15 0 0 0-3.63.37.8.8 0 0 1-1-.71L78 47.84a.56.56 0 0 0-.91-.46l-7.54 4.35a2 2 0 0 0-.9 1.41l-.75 8.39a2.85 2.85 0 0 1-.79 1.56A45.42 45.42 0 0 0 63 67.53a1.44 1.44 0 0 1-1.48.42l-4.84-1.69a1.18 1.18 0 0 0-1.36.5l-5.54 9.6a1.19 1.19 0 0 0 .22 1.43l3.88 3.35a1.43 1.43 0 0 1 .38 1.49 44.27 44.27 0 0 0-1.74 5.85 2.81 2.81 0 0 1-1 1.46l-6.89 4.85a2 2 0 0 0-.77 1.48V105a.56.56 0 0 0 .86.55l6.71-3a.79.79 0 0 1 1.12.52 14.63 14.63 0 0 0 1.5 3.32 1.87 1.87 0 0 1 .1 1.63l-4.47 9a1 1 0 0 0 .39 1.31l4.86 2.81a1 1 0 0 0 1.33-.32l5.58-8.38a1.88 1.88 0 0 1 1.46-.73 15.46 15.46 0 0 0 3.63-.36.8.8 0 0 1 1 .71l.73 7.32a.56.56 0 0 0 .91.47l7.54-4.36a2 2 0 0 0 .9-1.4l.76-8.4a2.77 2.77 0 0 1 .78-1.56 44.31 44.31 0 0 0 4.19-4.44 1.44 1.44 0 0 1 1.48-.42l4.84 1.69a1.17 1.17 0 0 0 1.36-.5L97 90.84a1.19 1.19 0 0 0-.24-1.43l-3.88-3.35a1.43 1.43 0 0 1-.38-1.49 45.89 45.89 0 0 0 1.75-5.85 2.83 2.83 0 0 1 1-1.46l6.89-4.85a2 2 0 0 0 .7-1.48ZM73.35 98.31c-7 4.06-12.74.77-12.74-7.35s5.71-18 12.74-22.07 12.74-.77 12.74 7.36-5.7 18-12.74 22.06Z",
    style: {
      fill: "#fff",
      transformOrigin: "73.35px 83.61px"
    },
    id: "el3jweghsy4mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.42 121.62a1.36 1.36 0 0 1-.68-.18l-4.85-2.81a1.39 1.39 0 0 1-.55-1.79l4.48-9a1.5 1.5 0 0 0-.09-1.27 15.58 15.58 0 0 1-1.53-3.41.5.5 0 0 0-.25-.31.44.44 0 0 0-.37 0l-6.71 3a.93.93 0 0 1-1.38-.89v-8.69a2.4 2.4 0 0 1 .93-1.78l6.89-4.85a2.45 2.45 0 0 0 .82-1.24 45.74 45.74 0 0 1 1.75-5.9 1.05 1.05 0 0 0-.27-1.08l-3.88-3.35a1.54 1.54 0 0 1-.32-1.89l5.59-9.6a1.54 1.54 0 0 1 1.8-.67l4.84 1.69a1.12 1.12 0 0 0 1.08-.31 45.11 45.11 0 0 1 4.22-4.47 2.45 2.45 0 0 0 .67-1.33l.75-8.39a2.43 2.43 0 0 1 1.09-1.69l7.54-4.36a.93.93 0 0 1 1.46.75l.73 7.33a.42.42 0 0 0 .56.38 15.1 15.1 0 0 1 3.72-.37 1.41 1.41 0 0 0 1.14-.56l5.58-8.39a1.4 1.4 0 0 1 1.82-.43l4.85 2.81a1.39 1.39 0 0 1 .55 1.8l-4.48 9a1.51 1.51 0 0 0 .08 1.28 15.58 15.58 0 0 1 1.53 3.41.5.5 0 0 0 .25.31.48.48 0 0 0 .37 0l6.71-3a1 1 0 0 1 1 0 1 1 0 0 1 .42.86v8.71a2.42 2.42 0 0 1-.93 1.79l-6.89 4.84a2.46 2.46 0 0 0-.81 1.25 47.83 47.83 0 0 1-1.76 5.89 1.07 1.07 0 0 0 .27 1.08L97 89.13a1.54 1.54 0 0 1 .29 1.87l-5.54 9.6a1.54 1.54 0 0 1-1.8.67l-4.84-1.67a1.1 1.1 0 0 0-1.08.31 44 44 0 0 1-4.22 4.47 2.45 2.45 0 0 0-.67 1.33l-.75 8.39a2.4 2.4 0 0 1-1.08 1.69l-7.54 4.36a1 1 0 0 1-1 .06 1 1 0 0 1-.51-.81l-.73-7.33a.48.48 0 0 0-.17-.32.47.47 0 0 0-.39-.06 15 15 0 0 1-3.72.37 1.5 1.5 0 0 0-1.14.56L56.57 121a1.38 1.38 0 0 1-1.15.62Zm-3.63-19.56a1.06 1.06 0 0 1 .46.1 1.22 1.22 0 0 1 .65.75 15.06 15.06 0 0 0 1.46 3.25 2.22 2.22 0 0 1 .12 2l-4.47 9a.63.63 0 0 0 .25.82l4.85 2.81a.66.66 0 0 0 .85-.2l5.57-8.39a2.25 2.25 0 0 1 1.78-.89 14.58 14.58 0 0 0 3.54-.36 1.23 1.23 0 0 1 1 .19 1.17 1.17 0 0 1 .47.85l.74 7.32a.29.29 0 0 0 .11.24.32.32 0 0 0 .25 0l7.54-4.36a1.66 1.66 0 0 0 .71-1.12l.76-8.39a3.1 3.1 0 0 1 .9-1.8 44.85 44.85 0 0 0 4.15-4.4 1.81 1.81 0 0 1 1.89-.53l4.84 1.69a.82.82 0 0 0 .92-.35l5.54-9.6a.79.79 0 0 0-.16-1l-3.91-3.35a1.83 1.83 0 0 1-.48-1.9 43.22 43.22 0 0 0 1.73-5.8A3.15 3.15 0 0 1 95 77l6.89-4.85a1.69 1.69 0 0 0 .61-1.18v-8.75a.28.28 0 0 0-.08-.24.32.32 0 0 0-.26 0l-6.71 3a1.17 1.17 0 0 1-1.62-.74A15.06 15.06 0 0 0 92.34 61a2.2 2.2 0 0 1-.12-2l4.47-9a.64.64 0 0 0-.25-.83l-4.85-2.77a.64.64 0 0 0-.84.2L85.17 55a2.21 2.21 0 0 1-1.78.89 14.63 14.63 0 0 0-3.54.36 1.24 1.24 0 0 1-1-.19 1.17 1.17 0 0 1-.47-.85l-.74-7.32c0-.12 0-.21-.1-.23a.28.28 0 0 0-.25.05l-7.54 4.35a1.67 1.67 0 0 0-.72 1.12l-.76 8.39a3.13 3.13 0 0 1-.9 1.81 44.72 44.72 0 0 0-4.15 4.39 1.82 1.82 0 0 1-1.89.54l-4.84-1.69a.81.81 0 0 0-.92.34l-5.54 9.6a.8.8 0 0 0 .16 1l3.89 3.35a1.83 1.83 0 0 1 .48 1.9 44.74 44.74 0 0 0-1.73 5.8 3.15 3.15 0 0 1-1.12 1.68l-6.88 4.85a1.67 1.67 0 0 0-.62 1.18V105c0 .12 0 .21.09.24a.32.32 0 0 0 .25 0l6.71-3a1.34 1.34 0 0 1 .53-.18Zm15.87-1.63a6.82 6.82 0 0 1-3.5-.91C61.63 98.07 60.24 95 60.24 91c0-8.23 5.8-18.27 12.93-22.39 3.52-2 6.85-2.35 9.37-.89s3.92 4.5 3.92 8.57c0 8.22-5.8 18.27-12.92 22.38a12 12 0 0 1-5.88 1.76ZM79 67.52a11.26 11.26 0 0 0-5.5 1.69C66.61 73.21 61 83 61 91c0 3.79 1.26 6.6 3.55 7.92s5.35 1 8.64-.89c6.92-4 12.55-13.75 12.55-21.74 0-3.8-1.26-6.61-3.55-7.93a6.1 6.1 0 0 0-3.19-.84Z",
    style: {
      fill: "#fff",
      transformOrigin: "73.3839px 83.6045px"
    },
    id: "elxrt268lsjui",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.62 46.85a3.68 3.68 0 0 1 1-2l3.93-3.61a2.4 2.4 0 0 0 .66-1.94l-.74-4.28a.8.8 0 0 0-.37-.59l-4.65-2.68a.72.72 0 0 0-.81.07L148.91 33l1.63-4.41a1 1 0 0 0-.45-1.22l-4.66-2.69a1 1 0 0 0-.31-.13l-3-.66a1.6 1.6 0 0 0-1.67.78L137.73 30a2.69 2.69 0 0 1-1.11 1l-.13-.42a.87.87 0 0 0-.37-.52l-4.67-2.69a.76.76 0 0 0-.88.12L126.14 31a2.49 2.49 0 0 0-.84 1.88l.26 4.21a3.27 3.27 0 0 1-.69 2c-.72.87-1.41 1.79-2.05 2.73a2.29 2.29 0 0 1-1.81.91l-2.85-.14a1.82 1.82 0 0 0-1.63 1l-2.68 6a1.15 1.15 0 0 0 .46 1.45l3.16 1.82a1.44 1.44 0 0 1 .08.82 27.42 27.42 0 0 0-.5 2.87 3.48 3.48 0 0 1-1 1.94l-3.93 3.62a2.37 2.37 0 0 0-.62 1.89l.73 4.28a.79.79 0 0 0 .36.58l4.69 2.7a.73.73 0 0 0 .8-.08l1.69-1.11-1.63 4.41a1 1 0 0 0 .39 1.2l4.67 2.7a1.11 1.11 0 0 0 .33.15l3 .66a1.62 1.62 0 0 0 1.68-.77l2.78-5.3a2.78 2.78 0 0 1 1.11-1l.13.43a.82.82 0 0 0 .38.51l4.57 2.64h.05a.77.77 0 0 0 .85-.14l4.43-3.48a2.48 2.48 0 0 0 .85-1.88l-.27-4.22a3.35 3.35 0 0 1 .69-2 34.06 34.06 0 0 0 2.06-2.72 2.26 2.26 0 0 1 1.8-.92l2.85.14a1.83 1.83 0 0 0 1.64-1l2.68-6a1.14 1.14 0 0 0-.6-1.52l-2.3-1a1.43 1.43 0 0 1-.79-1.59 24.45 24.45 0 0 0 .5-2.82ZM128 59.88c-.87-5 2.32-12.2 7.12-16a9.72 9.72 0 0 1 5.06-2.26 7.87 7.87 0 0 1 .55 1.86c.87 5.05-2.32 12.2-7.13 16a9.77 9.77 0 0 1-5 2.25 7.39 7.39 0 0 1-.6-1.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "134.355px 51.6902px"
    },
    id: "el1x16hhr1eks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.62 46.85a3.68 3.68 0 0 1 1-2l3.93-3.61a2.4 2.4 0 0 0 .66-1.94l-.74-4.28a.8.8 0 0 0-.37-.59l-4.65-2.68a.72.72 0 0 0-.81.07L148.91 33l1.63-4.41a1 1 0 0 0-.45-1.22l-4.66-2.69a1 1 0 0 0-.31-.13l-3-.66a1.6 1.6 0 0 0-1.67.78L137.73 30a2.69 2.69 0 0 1-1.11 1l-.13-.42a.87.87 0 0 0-.37-.52l-4.67-2.69a.76.76 0 0 0-.88.12L126.14 31a2.49 2.49 0 0 0-.84 1.88l.26 4.21a3.27 3.27 0 0 1-.69 2c-.72.87-1.41 1.79-2.05 2.73a2.29 2.29 0 0 1-1.81.91l-2.85-.14a1.82 1.82 0 0 0-1.63 1l-2.68 6a1.15 1.15 0 0 0 .46 1.45l3.16 1.82a1.44 1.44 0 0 1 .08.82 27.42 27.42 0 0 0-.5 2.87 3.48 3.48 0 0 1-1 1.94l-3.93 3.62a2.37 2.37 0 0 0-.62 1.89l.73 4.28a.79.79 0 0 0 .36.58l4.69 2.7a.73.73 0 0 0 .8-.08l1.69-1.11-1.63 4.41a1 1 0 0 0 .39 1.2l4.67 2.7a1.11 1.11 0 0 0 .33.15l3 .66a1.62 1.62 0 0 0 1.68-.77l2.78-5.3a2.78 2.78 0 0 1 1.11-1l.13.43a.82.82 0 0 0 .38.51l4.57 2.64h.05a.77.77 0 0 0 .85-.14l4.43-3.48a2.48 2.48 0 0 0 .85-1.88l-.27-4.22a3.35 3.35 0 0 1 .69-2 34.06 34.06 0 0 0 2.06-2.72 2.26 2.26 0 0 1 1.8-.92l2.85.14a1.83 1.83 0 0 0 1.64-1l2.68-6a1.14 1.14 0 0 0-.6-1.52l-2.3-1a1.43 1.43 0 0 1-.79-1.59 24.45 24.45 0 0 0 .5-2.82ZM128 59.88c-.87-5 2.32-12.2 7.12-16a9.72 9.72 0 0 1 5.06-2.26 7.87 7.87 0 0 1 .55 1.86c.87 5.05-2.32 12.2-7.13 16a9.77 9.77 0 0 1-5 2.25 7.39 7.39 0 0 1-.6-1.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "134.355px 51.6902px"
    },
    className: "animable",
    id: "elu8kmmq7fnv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.57 69.3a1.14 1.14 0 0 0-1.58-.36l-2.24 1.47-1.63 4.42a1 1 0 0 0 .4 1.19l4.62 2.67a1 1 0 0 1-.35-1.17l2-5.42a2 2 0 0 0-.46-1.87 7 7 0 0 1-.76-.93Zm13.64 6.75a.82.82 0 0 1-.37-.51l-1-3.32a1 1 0 0 0-1.4-.64 13.81 13.81 0 0 1-1.82.6 2.75 2.75 0 0 0-.58.24l.13.43a.84.84 0 0 0 .39.51Z",
    style: {
      opacity: 0.1,
      transformOrigin: "127.634px 73.7259px"
    },
    className: "animable",
    id: "elw0hfnvzwmo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24 62.18c-4.15 3.26-8.14 2.95-9.7-.45a9.63 9.63 0 0 0 5-2.24c4.81-3.78 8-10.93 7.13-16a7.34 7.34 0 0 0-.56-1.85c2.64-.23 4.68 1.36 5.23 4.54.9 5.07-2.34 12.22-7.1 16Z",
    style: {
      opacity: 0.1,
      transformOrigin: "137.015px 53.0394px"
    },
    className: "animable",
    id: "elkobebibnj8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83 42.55a1.87 1.87 0 0 1-.81.17l-2.86-.13A1.74 1.74 0 0 0 117 43l4.67 2.69a1.78 1.78 0 0 1 1.18-.43l2.85.13a1.88 1.88 0 0 0 .82-.15Zm9.62-15.21a.74.74 0 0 0-.87.12l-4.44 3.48a2.5 2.5 0 0 0-.73 1.17l4.67 2.69a2.35 2.35 0 0 1 .73-1.17l4.43-3.47a.75.75 0 0 1 .88-.12ZM116 58.54l-3.88 3.57a2.2 2.2 0 0 0-.61 1.11l4.66 2.68a2.24 2.24 0 0 1 .61-1.1l3.88-3.56Zm29.41-33.88a.77.77 0 0 0-.31-.12l-3-.67a1.6 1.6 0 0 0-1.67.78l-2.7 5.35a2.6 2.6 0 0 1-.63.71l4.66 2.69a2.31 2.31 0 0 0 .63-.71l2.79-5.3a1.59 1.59 0 0 1 1.67-.78l3 .67a1.33 1.33 0 0 1 .3.11Zm6 7.13a.78.78 0 0 0-.82.07L148.91 33l-.38 1a2 2 0 0 0 .47 1.88 7 7 0 0 1 .76.93 2.2 2.2 0 0 0 .2.23l.18.13a.93.93 0 0 0 .39.15 1 1 0 0 0 .52 0 .88.88 0 0 0 .28-.13l3.93-2.58a1.09 1.09 0 0 1 .29-.14.63.63 0 0 1 .33 0 .6.6 0 0 1 .19.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "133.79px 44.8725px"
    },
    id: "elc27z55l8hmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83 42.55a1.87 1.87 0 0 1-.81.17l-2.86-.13A1.74 1.74 0 0 0 117 43l4.67 2.69a1.78 1.78 0 0 1 1.18-.43l2.85.13a1.88 1.88 0 0 0 .82-.15Zm9.62-15.21a.74.74 0 0 0-.87.12l-4.44 3.48a2.5 2.5 0 0 0-.73 1.17l4.67 2.69a2.35 2.35 0 0 1 .73-1.17l4.43-3.47a.75.75 0 0 1 .88-.12ZM116 58.54l-3.88 3.57a2.2 2.2 0 0 0-.61 1.11l4.66 2.68a2.24 2.24 0 0 1 .61-1.1l3.88-3.56Zm29.41-33.88a.77.77 0 0 0-.31-.12l-3-.67a1.6 1.6 0 0 0-1.67.78l-2.7 5.35a2.6 2.6 0 0 1-.63.71l4.66 2.69a2.31 2.31 0 0 0 .63-.71l2.79-5.3a1.59 1.59 0 0 1 1.67-.78l3 .67a1.33 1.33 0 0 1 .3.11Zm6 7.13a.78.78 0 0 0-.82.07L148.91 33l-.38 1a2 2 0 0 0 .47 1.88 7 7 0 0 1 .76.93 2.2 2.2 0 0 0 .2.23l.18.13a.93.93 0 0 0 .39.15 1 1 0 0 0 .52 0 .88.88 0 0 0 .28-.13l3.93-2.58a1.09 1.09 0 0 1 .29-.14.63.63 0 0 1 .33 0 .6.6 0 0 1 .19.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "133.79px 44.8725px"
    },
    className: "animable",
    id: "el2fvjf3kfckn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.17 39.35-.74-4.28a.71.71 0 0 0-1.17-.51l-3.92 2.59a1.15 1.15 0 0 1-1.58-.36 7.8 7.8 0 0 0-.76-.94 1.94 1.94 0 0 1-.46-1.86l2-5.42a1 1 0 0 0-.73-1.34l-3-.66a1.59 1.59 0 0 0-1.68.77l-2.78 5.3a2.91 2.91 0 0 1-1.68 1.27 14.31 14.31 0 0 0-1.82.6 1 1 0 0 1-1.4-.64l-1-3.32a.74.74 0 0 0-1.25-.4l-4.43 3.49a2.47 2.47 0 0 0-.84 1.88l.26 4.22a3.37 3.37 0 0 1-.69 2c-.73.87-1.41 1.78-2.06 2.72a2.29 2.29 0 0 1-1.8.92l-2.85-.14a1.81 1.81 0 0 0-1.64 1l-2.68 6a1.15 1.15 0 0 0 .6 1.52l2.3 1a1.43 1.43 0 0 1 .79 1.59 26.74 26.74 0 0 0-.49 2.86 3.61 3.61 0 0 1-1 1.95l-3.93 3.61a2.38 2.38 0 0 0-.66 1.93l.82 4.3a.7.7 0 0 0 1.17.5l3.93-2.56a1.15 1.15 0 0 1 1.58.36 8.77 8.77 0 0 0 .76.93 1.92 1.92 0 0 1 .46 1.87l-2 5.42a1 1 0 0 0 .74 1.34l3 .66a1.62 1.62 0 0 0 1.68-.77l2.78-5.3a2.94 2.94 0 0 1 1.68-1.27 13.81 13.81 0 0 0 1.82-.6 1 1 0 0 1 1.4.64l1 3.32a.74.74 0 0 0 1.25.39l4.43-3.48a2.48 2.48 0 0 0 .85-1.88l-.27-4.22a3.35 3.35 0 0 1 .69-2 34.06 34.06 0 0 0 2.06-2.72 2.26 2.26 0 0 1 1.8-.92l2.85.14a1.83 1.83 0 0 0 1.64-1l2.68-6a1.14 1.14 0 0 0-.6-1.52l-2.3-1a1.43 1.43 0 0 1-.79-1.59 24.45 24.45 0 0 0 .49-2.86 3.68 3.68 0 0 1 1-2l3.93-3.61a2.4 2.4 0 0 0 .56-1.92Zm-18.93 22.83c-4.8 3.78-9.4 2.75-10.27-2.3s2.32-12.2 7.12-16 9.41-2.75 10.28 2.29-2.37 12.23-7.13 16.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "136.63px 53.0433px"
    },
    id: "elfz1kecxp3r9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "136.662px 53.0723px"
    },
    className: "animable",
    id: "eloqphj9etq9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.17 39.35-.74-4.28a.71.71 0 0 0-1.17-.51l-3.92 2.59a1.15 1.15 0 0 1-1.58-.36 7.8 7.8 0 0 0-.76-.94 1.94 1.94 0 0 1-.46-1.86l2-5.42a1 1 0 0 0-.73-1.34l-3-.66a1.59 1.59 0 0 0-1.68.77l-2.78 5.3a2.91 2.91 0 0 1-1.68 1.27 14.31 14.31 0 0 0-1.82.6 1 1 0 0 1-1.4-.64l-1-3.32a.74.74 0 0 0-1.25-.4l-4.43 3.49a2.47 2.47 0 0 0-.84 1.88l.26 4.22a3.37 3.37 0 0 1-.69 2c-.73.87-1.41 1.78-2.06 2.72a2.29 2.29 0 0 1-1.8.92l-2.85-.14a1.81 1.81 0 0 0-1.64 1l-2.68 6a1.15 1.15 0 0 0 .6 1.52l2.3 1a1.43 1.43 0 0 1 .79 1.59 26.74 26.74 0 0 0-.49 2.86 3.61 3.61 0 0 1-1 1.95l-3.93 3.61a2.38 2.38 0 0 0-.66 1.93l.82 4.3a.7.7 0 0 0 1.17.5l3.93-2.56a1.15 1.15 0 0 1 1.58.36 8.77 8.77 0 0 0 .76.93 1.92 1.92 0 0 1 .46 1.87l-2 5.42a1 1 0 0 0 .74 1.34l3 .66a1.62 1.62 0 0 0 1.68-.77l2.78-5.3a2.94 2.94 0 0 1 1.68-1.27 13.81 13.81 0 0 0 1.82-.6 1 1 0 0 1 1.4.64l1 3.32a.74.74 0 0 0 1.25.39l4.43-3.48a2.48 2.48 0 0 0 .85-1.88l-.27-4.22a3.35 3.35 0 0 1 .69-2 34.06 34.06 0 0 0 2.06-2.72 2.26 2.26 0 0 1 1.8-.92l2.85.14a1.83 1.83 0 0 0 1.64-1l2.68-6a1.14 1.14 0 0 0-.6-1.52l-2.3-1a1.43 1.43 0 0 1-.79-1.59 24.45 24.45 0 0 0 .49-2.86 3.68 3.68 0 0 1 1-2l3.93-3.61a2.4 2.4 0 0 0 .56-1.92Zm-18.93 22.83c-4.8 3.78-9.4 2.75-10.27-2.3s2.32-12.2 7.12-16 9.41-2.75 10.28 2.29-2.37 12.23-7.13 16.01Z",
    style: {
      fill: "#fff",
      transformOrigin: "136.63px 53.0433px"
    },
    id: "elfn0c3sfid9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77 80a1.72 1.72 0 0 1-.39 0l-2.95-.66a1.46 1.46 0 0 1-1.07-2l2-5.42a1.49 1.49 0 0 0-.36-1.39 9.7 9.7 0 0 1-.81-1 .68.68 0 0 0-.94-.24l-3.93 2.59a1.16 1.16 0 0 1-1.87-.82l-.74-4.28a2.88 2.88 0 0 1 .8-2.35l3.93-3.61a3.1 3.1 0 0 0 .81-1.66 26.32 26.32 0 0 1 .51-2.92 1 1 0 0 0-.53-1.06l-2.3-1a1.61 1.61 0 0 1-.83-2.13l2.67-6a2.3 2.3 0 0 1 2.08-1.27l2.85.14a1.8 1.8 0 0 0 1.4-.72c.66-1 1.36-1.88 2.09-2.76a2.78 2.78 0 0 0 .58-1.71l-.26-4.22a3 3 0 0 1 1-2.27l4.49-3.45a1.27 1.27 0 0 1 1.16-.25 1.24 1.24 0 0 1 .81.88l1 3.32a.59.59 0 0 0 .28.35.61.61 0 0 0 .51 0 15.88 15.88 0 0 1 1.88-.62 2.5 2.5 0 0 0 1.39-1l2.78-5.3a2.07 2.07 0 0 1 2.18-1l3 .66a1.51 1.51 0 0 1 1 .73 1.48 1.48 0 0 1 .07 1.22l-2 5.41a1.5 1.5 0 0 0 .36 1.4 8.72 8.72 0 0 1 .81 1 .68.68 0 0 0 1 .23l3.77-2.64a1.24 1.24 0 0 1 1.18-.15 1.21 1.21 0 0 1 .69 1l.74 4.29a2.82 2.82 0 0 1-.8 2.35l-3.93 3.61a3.17 3.17 0 0 0-.81 1.66 29.09 29.09 0 0 1-.5 2.91 1 1 0 0 0 .52 1.07l2.3 1a1.6 1.6 0 0 1 .84 2.13l-2.68 6a2.26 2.26 0 0 1-2.08 1.28l-2.85-.14a1.76 1.76 0 0 0-1.4.71 34.41 34.41 0 0 1-2.09 2.76 2.9 2.9 0 0 0-.58 1.72l.26 4.22a2.94 2.94 0 0 1-1 2.27l-4.43 3.48a1.26 1.26 0 0 1-1.17.26 1.28 1.28 0 0 1-.81-.88l-1-3.32a.55.55 0 0 0-.28-.35.64.64 0 0 0-.51 0 14.31 14.31 0 0 1-1.88.63 2.4 2.4 0 0 0-1.38 1L128.56 79a2.08 2.08 0 0 1-1.79 1Zm-4.18-11.7a1.65 1.65 0 0 1 1.35.73 8.05 8.05 0 0 0 .73.89 2.39 2.39 0 0 1 .55 2.34l-2 5.41a.58.58 0 0 0 0 .47.54.54 0 0 0 .38.27l3 .67a1.15 1.15 0 0 0 1.17-.55l2.79-5.3a3.37 3.37 0 0 1 2-1.49 13.91 13.91 0 0 0 1.76-.58 1.51 1.51 0 0 1 1.25 0 1.45 1.45 0 0 1 .76.91l1 3.32a.4.4 0 0 0 .2.27.37.37 0 0 0 .33-.11l4.43-3.48a2 2 0 0 0 .67-1.49l-.26-4.22a3.73 3.73 0 0 1 .79-2.36c.71-.85 1.39-1.75 2-2.69a2.72 2.72 0 0 1 2.21-1.12l2.85.14a1.37 1.37 0 0 0 1.19-.73l2.68-6a.7.7 0 0 0 0-.53.68.68 0 0 0-.38-.38l-2.3-1a1.9 1.9 0 0 1-1.06-2.11 26.91 26.91 0 0 0 .49-2.82 4 4 0 0 1 1.1-2.23L156.2 41a1.94 1.94 0 0 0 .52-1.52l-.72-4.33a.34.34 0 0 0-.15-.28c-.08 0-.19 0-.31.08l-3.93 2.58a1.59 1.59 0 0 1-2.2-.48 7.67 7.67 0 0 0-.72-.88 2.38 2.38 0 0 1-.56-2.34l2-5.42a.55.55 0 0 0 0-.47.58.58 0 0 0-.38-.27l-3-.66a1.16 1.16 0 0 0-1.17.54l-2.78 5.3a3.35 3.35 0 0 1-2 1.5 14 14 0 0 0-1.77.58 1.53 1.53 0 0 1-1.24 0 1.49 1.49 0 0 1-.77-.91l-1-3.32a.37.37 0 0 0-.2-.27.39.39 0 0 0-.33.1l-4.4 3.47a2 2 0 0 0-.67 1.49l.27 4.22a3.8 3.8 0 0 1-.8 2.36c-.71.85-1.39 1.76-2 2.69a2.75 2.75 0 0 1-2.2 1.11l-2.85-.14a1.4 1.4 0 0 0-1.2.74l-2.68 6a.7.7 0 0 0 0 .53.71.71 0 0 0 .37.39l2.3 1a1.88 1.88 0 0 1 1.06 2.11 26.73 26.73 0 0 0-.49 2.81 3.94 3.94 0 0 1-1.1 2.23l-3.93 3.61a1.94 1.94 0 0 0-.52 1.52l.74 4.29c0 .14.08.25.16.28a.38.38 0 0 0 .31-.08l3.92-2.58a1.51 1.51 0 0 1 .81-.28Zm10.12-3.39a5.29 5.29 0 0 1-1.87-.33 5.6 5.6 0 0 1-3.32-4.58c-.9-5.19 2.38-12.55 7.29-16.41 2.71-2.13 5.51-2.88 7.68-2a5.63 5.63 0 0 1 3.33 4.62c.89 5.18-2.38 12.55-7.3 16.41a9.72 9.72 0 0 1-5.81 2.29Zm7.9-22.82a8.84 8.84 0 0 0-5.23 2.18c-4.68 3.67-7.8 10.65-7 15.54a4.7 4.7 0 0 0 2.75 3.92c1.86.71 4.34 0 6.79-1.91 4.68-3.68 7.8-10.65 6.95-15.54a4.68 4.68 0 0 0-2.75-3.92 4.39 4.39 0 0 0-1.51-.27Z",
    style: {
      fill: "#fff",
      transformOrigin: "136.662px 53.0723px"
    },
    id: "elyrqz5sl635o",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-123",
    className: "animable",
    style: {
      transformOrigin: "423.691px 141.225px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-123",
    className: "animable",
    style: {
      transformOrigin: "423.691px 75.817px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-123",
    className: "animable",
    style: {
      transformOrigin: "423.691px 75.817px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410 65 33.49-19.36c1.32-.76 2.39-.14 2.39 1.38V86a5.27 5.27 0 0 1-2.39 4.13L410 109.47c-1.31.76-2.38.14-2.38-1.38V69.17A5.28 5.28 0 0 1 410 65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "426.75px 77.555px"
    },
    id: "elinz19j63ei8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 65 33.49-19.36c1.32-.76 2.39-.14 2.39 1.38V86a5.27 5.27 0 0 1-2.39 4.13L410 109.47c-1.31.76-2.38.14-2.38-1.38V69.17A5.28 5.28 0 0 1 410 65Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "426.75px 77.555px"
    },
    className: "animable",
    id: "el67rw6813338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.29 66.82-6.08-3.52a4.94 4.94 0 0 0-.7 2.36v38.91a1.68 1.68 0 0 0 .68 1.53c.44.27 5.64 3.24 6.05 3.51a1.73 1.73 0 0 1-.65-1.52V69.17a4.9 4.9 0 0 1 .7-2.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "404.896px 86.455px"
    },
    id: "elpydhex2ccwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05 45.46c-.85-.51-5.58-3.22-6-3.46a1.69 1.69 0 0 0-1.71.16L403.9 61.53a4.88 4.88 0 0 0-1.69 1.77l6.08 3.52A5 5 0 0 1 410 65l33.5-19.36a1.77 1.77 0 0 1 1.55-.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.63px 54.3296px"
    },
    id: "eltug0zwuaguk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05 45.46c-.85-.51-5.58-3.22-6-3.46a1.69 1.69 0 0 0-1.71.16L403.9 61.53a4.88 4.88 0 0 0-1.69 1.77l6.08 3.52A5 5 0 0 1 410 65l33.5-19.36a1.77 1.77 0 0 1 1.55-.18Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "423.63px 54.3296px"
    },
    className: "animable",
    id: "el2a55d93h394"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m414.76 84.72 4.62 2.11a2.13 2.13 0 0 1 .42.32.94.94 0 0 1 .23.69v2.67a1.33 1.33 0 0 1-.12.55.87.87 0 0 1-.31.36h-.09a.28.28 0 0 1-.13 0l-7.15-3.3a1 1 0 0 1-.44-.29 1.12 1.12 0 0 1-.16-.69v-1.28a2.24 2.24 0 0 1 .16-.86 6.12 6.12 0 0 1 .44-.8l7.15-11.55a.69.69 0 0 1 .13-.15.28.28 0 0 1 .09-.07.24.24 0 0 1 .31 0 .55.55 0 0 1 .12.4v2.67a2.21 2.21 0 0 1-.23.95c-.15.32-.29.59-.42.82Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "415.829px 81.9004px"
    },
    id: "els1hi73sxev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.63 64a4.9 4.9 0 0 1 .3-.83 1.54 1.54 0 0 1 .6-.64l1.51-.87a.24.24 0 0 1 .31 0 .55.55 0 0 1 .14.41 2 2 0 0 1 0 .31l-6.91 29.43a4 4 0 0 1-.28.79 1.49 1.49 0 0 1-.62.67l-1.45.83a.22.22 0 0 1-.31 0 .53.53 0 0 1-.13-.41 1.24 1.24 0 0 1 0-.3Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "426.638px 77.8836px"
    },
    id: "elrfwkgprbdqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84 68.93a1.91 1.91 0 0 1-.43-.32.94.94 0 0 1-.23-.69v-2.67a1.2 1.2 0 0 1 .13-.55.79.79 0 0 1 .3-.36h.23L441 67.6a1.21 1.21 0 0 1 .44.29 1.13 1.13 0 0 1 .15.69v1.32a2.24 2.24 0 0 1-.15.86 7.6 7.6 0 0 1-.44.8l-7.15 11.55a1.08 1.08 0 0 1-.14.15.28.28 0 0 1-.09.07.23.23 0 0 1-.3 0 .51.51 0 0 1-.13-.4v-2.68a2.21 2.21 0 0 1 .23-1 8.64 8.64 0 0 1 .43-.82l4.6-7.43Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "437.387px 73.8628px"
    },
    id: "el4z1ycxng1b",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-123",
    className: "animable",
    style: {
      transformOrigin: "423.691px 141.227px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-123",
    className: "animable",
    style: {
      transformOrigin: "423.691px 141.227px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410 130.45 33.49-19.36c1.32-.76 2.39-.14 2.39 1.38v38.91a5.27 5.27 0 0 1-2.39 4.13L410 174.88c-1.31.76-2.38.14-2.38-1.38v-38.92a5.28 5.28 0 0 1 2.38-4.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "426.75px 142.985px"
    },
    id: "elcab8a6s8di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 130.45 33.49-19.36c1.32-.76 2.39-.14 2.39 1.38v38.91a5.27 5.27 0 0 1-2.39 4.13L410 174.88c-1.31.76-2.38.14-2.38-1.38v-38.92a5.28 5.28 0 0 1 2.38-4.13Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "426.75px 142.985px"
    },
    className: "animable",
    id: "ele1earsl1sk5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.29 132.23-6.08-3.52a4.91 4.91 0 0 0-.7 2.36V170a1.68 1.68 0 0 0 .68 1.53c.44.27 5.64 3.24 6.05 3.51a1.73 1.73 0 0 1-.65-1.52v-38.94a4.9 4.9 0 0 1 .7-2.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "404.896px 151.875px"
    },
    id: "el5xza7dhj7gw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05 110.87c-.85-.52-5.58-3.23-6-3.46a1.69 1.69 0 0 0-1.71.16l-33.44 19.37a4.88 4.88 0 0 0-1.69 1.77l6.08 3.52a4.9 4.9 0 0 1 1.68-1.78l33.5-19.36a1.77 1.77 0 0 1 1.58-.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.63px 119.74px"
    },
    id: "eltv042ydgt8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05 110.87c-.85-.52-5.58-3.23-6-3.46a1.69 1.69 0 0 0-1.71.16l-33.44 19.37a4.88 4.88 0 0 0-1.69 1.77l6.08 3.52a4.9 4.9 0 0 1 1.68-1.78l33.5-19.36a1.77 1.77 0 0 1 1.58-.22Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "423.63px 119.74px"
    },
    className: "animable",
    id: "elcciapkhfe6u"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.36 160a1.59 1.59 0 0 1-.17.69 1.14 1.14 0 0 1-.38.48 3.56 3.56 0 0 1-1.94.56 2.09 2.09 0 0 1-1.49-.77 5.27 5.27 0 0 1-1-2.14 15.72 15.72 0 0 1-.33-3.51 7.69 7.69 0 0 0-.29-2.36c-.19-.56-.48-.85-.88-.87h-.35c-.39-.05-.59-.32-.59-.82v-1.64a2.44 2.44 0 0 1 .59-1.5l.35-.42a4.59 4.59 0 0 0 .88-1.9 11.34 11.34 0 0 0 .29-2.68 22 22 0 0 1 .33-3.92 16 16 0 0 1 1-3.26 10.74 10.74 0 0 1 1.49-2.49 7.22 7.22 0 0 1 1.94-1.67.3.3 0 0 1 .38 0 .67.67 0 0 1 .17.5v2.08a1.59 1.59 0 0 1-.17.69 1.14 1.14 0 0 1-.38.48 3.84 3.84 0 0 0-1.54 2.36 17.16 17.16 0 0 0-.53 4.71 14.09 14.09 0 0 1-.13 2 11.13 11.13 0 0 1-.36 1.64 9.25 9.25 0 0 1-.5 1.28 11 11 0 0 1-.54 1 2.12 2.12 0 0 1 .54.36 2.21 2.21 0 0 1 .5.7 4.78 4.78 0 0 1 .36 1.23 11 11 0 0 1 .13 1.88 11 11 0 0 0 .53 4.09c.36.76.87 1 1.54.57a.3.3 0 0 1 .38 0 .67.67 0 0 1 .17.5Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "417.651px 146.721px"
    },
    id: "el5nlx5kyas5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.85 151.85a1.59 1.59 0 0 1 .17-.69 1.08 1.08 0 0 1 .39-.48 3.85 3.85 0 0 0 1.53-2.34 17 17 0 0 0 .53-4.7 14.09 14.09 0 0 1 .13-2 11.43 11.43 0 0 1 .4-1.64 9.13 9.13 0 0 1 .49-1.27 11.28 11.28 0 0 1 .55-1 2 2 0 0 1-.55-.36 2.26 2.26 0 0 1-.49-.71 4.82 4.82 0 0 1-.36-1.22 11.18 11.18 0 0 1-.13-1.89 11.09 11.09 0 0 0-.53-4.1c-.36-.78-.87-1-1.53-.59a.29.29 0 0 1-.39 0 .66.66 0 0 1-.17-.5v-2.08a1.59 1.59 0 0 1 .17-.69 1.08 1.08 0 0 1 .39-.48 3.59 3.59 0 0 1 1.93-.56 2.06 2.06 0 0 1 1.49.78 5.19 5.19 0 0 1 1 2.15 15.91 15.91 0 0 1 .33 3.53 7.62 7.62 0 0 0 .29 2.35c.19.56.48.85.88.87h.35c.39.05.59.32.59.83v1.63a2.47 2.47 0 0 1-.59 1.51l-.35.42a4.61 4.61 0 0 0-.88 1.89 11.34 11.34 0 0 0-.29 2.68 21.65 21.65 0 0 1-.33 3.9 16.12 16.12 0 0 1-1 3.25 10.74 10.74 0 0 1-1.49 2.49 7.34 7.34 0 0 1-1.93 1.67.31.31 0 0 1-.39 0 .66.66 0 0 1-.17-.5Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "435.58px 139.559px"
    },
    id: "eliof1hl021e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "423.691px 206.635px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "423.691px 206.635px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410 195.86 33.49-19.36c1.32-.76 2.39-.14 2.39 1.38v38.91a5.27 5.27 0 0 1-2.39 4.13L410 240.28c-1.31.77-2.38.15-2.38-1.37V200a5.28 5.28 0 0 1 2.38-4.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "426.75px 208.393px"
    },
    id: "el2g8pxmrv7ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 195.86 33.49-19.36c1.32-.76 2.39-.14 2.39 1.38v38.91a5.27 5.27 0 0 1-2.39 4.13L410 240.28c-1.31.77-2.38.15-2.38-1.37V200a5.28 5.28 0 0 1 2.38-4.14Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "426.75px 208.393px"
    },
    className: "animable",
    id: "eldugmeqef86s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.29 197.64-6.08-3.52a4.9 4.9 0 0 0-.7 2.35v38.92a1.68 1.68 0 0 0 .68 1.53c.44.27 5.64 3.24 6.05 3.51a1.73 1.73 0 0 1-.65-1.52V200a4.9 4.9 0 0 1 .7-2.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "404.896px 217.275px"
    },
    id: "elgbuqorzov9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05 176.28c-.85-.52-5.58-3.23-6-3.46a1.69 1.69 0 0 0-1.71.16l-33.44 19.37a4.73 4.73 0 0 0-1.69 1.77l6.08 3.52a4.9 4.9 0 0 1 1.68-1.78l33.5-19.36a1.74 1.74 0 0 1 1.58-.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.63px 185.15px"
    },
    id: "elke1ohcol10k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05 176.28c-.85-.52-5.58-3.23-6-3.46a1.69 1.69 0 0 0-1.71.16l-33.44 19.37a4.73 4.73 0 0 0-1.69 1.77l6.08 3.52a4.9 4.9 0 0 1 1.68-1.78l33.5-19.36a1.74 1.74 0 0 1 1.58-.22Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "423.63px 185.15px"
    },
    className: "animable",
    id: "elw8bww1kcbjm"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Gear--inject-123",
    d: "m438.12 204.41-2.44-.12c-.17 0-.29-.25-.29-.53a13.31 13.31 0 0 0-.09-2 1.38 1.38 0 0 1 .15-.84l2.41-3.42a.84.84 0 0 0 0-.76l-1.2-2.58c-.11-.24-.31-.32-.45-.17l-2.68 2.83a.4.4 0 0 1-.54 0 4.26 4.26 0 0 0-1.17-.71.55.55 0 0 1-.24-.6l.6-3.84c0-.27-.06-.48-.23-.46l-2.85.34c-.17 0-.36.24-.44.48l-1.17 4a1.14 1.14 0 0 1-.43.59 11.42 11.42 0 0 0-1.8 1.19.35.35 0 0 1-.51-.15l-1.32-2c-.14-.2-.35-.24-.48-.07l-2.79 3.41a.94.94 0 0 0-.09.77l.84 2.62a1.25 1.25 0 0 1-.05.84 23 23 0 0 0-1.2 2.5.9.9 0 0 1-.47.49l-2.69.75a.75.75 0 0 0-.41.55l-1 4.36c-.06.26 0 .47.21.48l2.43.13c.17 0 .3.24.29.53a14.76 14.76 0 0 0 .1 2 1.4 1.4 0 0 1-.16.84l-2.41 3.42a.85.85 0 0 0 0 .75l1.2 2.59c.11.24.31.32.45.17l2.68-2.83a.4.4 0 0 1 .54 0 4.28 4.28 0 0 0 1.18.7.56.56 0 0 1 .23.6l-.59 3.85c0 .27.06.47.23.45l2.84-.33a.67.67 0 0 0 .44-.49l1.18-4a1 1 0 0 1 .42-.59 11.34 11.34 0 0 0 1.81-1.2c.14-.12.37-.05.51.15l1.32 2c.13.21.35.24.48.08l2.81-3.45a.91.91 0 0 0 .08-.77l-.83-2.62a1.14 1.14 0 0 1 .05-.84 25 25 0 0 0 1.2-2.5.91.91 0 0 1 .46-.5l2.7-.74a.76.76 0 0 0 .4-.55l1-4.36c.04-.21-.05-.43-.22-.44Zm-6.7 3.43c-.9 4-3.73 7.44-6.32 7.75s-4-2.67-3.08-6.64 3.72-7.45 6.31-7.76 3.98 2.67 3.09 6.65Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "426.709px 208.385px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-123",
    className: "animable",
    style: {
      transformOrigin: "388.5px 420.237px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-123",
    className: "animable",
    style: {
      transformOrigin: "388.5px 420.237px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.58 398.73c0-7.65-5.06-15.3-15.17-21.14-20.21-11.67-53-11.67-73.21 0-10.11 5.84-15.2 13.49-15.2 21.14v14.09c0 7.65 5.06 15.3 15.17 21.13 20.22 11.68 53 11.68 73.21 0 10.11-5.83 15.17-13.48 15.17-21.13v-14.09Zm-85.88-16.8c9-5.21 21.14-8.09 34.11-8.09s25.07 2.88 34.1 8.09c8.16 4.71 12.66 10.68 12.66 16.8s-4.5 12.08-12.66 16.8c-9 5.21-21.14 8.08-34.1 8.08s-25.08-2.87-34.11-8.08c-8.16-4.72-12.66-10.68-12.66-16.8s4.5-12.09 12.66-16.8Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "416.79px 405.774px"
    },
    id: "elwafta72b1lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.58 398.73c0-7.65-5.06-15.3-15.17-21.14-20.21-11.67-53-11.67-73.21 0-10.11 5.84-15.2 13.49-15.2 21.14v14.09c0 7.65 5.06 15.3 15.17 21.13 20.22 11.68 53 11.68 73.21 0 10.11-5.83 15.17-13.48 15.17-21.13v-14.09Zm-85.88-16.8c9-5.21 21.14-8.09 34.11-8.09s25.07 2.88 34.1 8.09c8.16 4.71 12.66 10.68 12.66 16.8s-4.5 12.08-12.66 16.8c-9 5.21-21.14 8.08-34.1 8.08s-25.08-2.87-34.11-8.08c-8.16-4.72-12.66-10.68-12.66-16.8s4.5-12.09 12.66-16.8Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "416.79px 405.774px"
    },
    className: "animable",
    id: "el7816qkntbbq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.19 419.86c20.22 11.68 53 11.68 73.22 0s20.22-30.6 0-42.27-53-11.67-73.22 0-20.19 30.6 0 42.27ZM370 398.73c0-6.12 4.49-12.09 12.66-16.8 9-5.21 21.14-8.09 34.1-8.09s25.08 2.88 34.11 8.09c8.16 4.71 12.66 10.68 12.66 16.8s-4.5 12.08-12.66 16.8c-9 5.21-21.15 8.08-34.11 8.08s-25.07-2.87-34.1-8.08c-8.13-4.72-12.66-10.68-12.66-16.8Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "416.806px 398.729px"
    },
    className: "animable",
    id: "ela82rjvkfrdo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 398.73a14 14 0 0 0 2 7c2.05-3.56 5.66-6.89 10.64-9.76 9-5.21 21.14-8.09 34.11-8.09s25.07 2.88 34.09 8.09c5 2.87 8.59 6.2 10.66 9.76a14 14 0 0 0 2-7c0-6.12-4.5-12.09-12.67-16.81-9-5.2-21.14-8.08-34.09-8.08s-25.09 2.88-34.11 8.08c-8.1 4.72-12.63 10.69-12.63 16.81Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "416.75px 389.785px"
    },
    id: "elgsit99tqbi7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7 388.31c9-5.22 21.14-8.09 34.1-8.09s25.08 2.87 34.11 8.09c6.73 3.89 11 8.63 12.24 13.61-1.28 5-5.51 9.72-12.24 13.61-9 5.21-21.15 8.08-34.11 8.08s-25.07-2.87-34.1-8.08c-6.74-3.89-11-8.64-12.25-13.61 1.28-4.98 5.55-9.72 12.25-13.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "416.8px 401.915px"
    },
    className: "animable",
    id: "elbhqj99p5vm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6 427.79v14.07a67.67 67.67 0 0 1-24.4-7.86c-10.11-5.88-15.2-13.53-15.2-21.18v-14.09a17.78 17.78 0 0 1 .62-4.62c-2.45 9.1 2.4 18.74 14.54 25.75a68.07 68.07 0 0 0 24.44 7.93Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.4,
      transformOrigin: "384.8px 417.985px"
    },
    className: "animable",
    id: "elmejm3ecerf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.74 428.83a8.06 8.06 0 0 0-3.6-6.3 2.58 2.58 0 0 0-2.56-.26l-17.43 10a2.56 2.56 0 0 0-1.07 2.33 8 8 0 0 0 3.61 6.3 2.57 2.57 0 0 0 2.56.27l17.43-9.95a2.54 2.54 0 0 0 1.06-2.39Z",
    style: {
      fill: "#37474f",
      transformOrigin: "369.414px 431.719px"
    },
    id: "el63qedb7nhpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.65 431.18a2.54 2.54 0 0 0 1.09-2.35 7 7 0 0 0-.62-2.71L358.65 439a6.8 6.8 0 0 0 2 1.89 2.57 2.57 0 0 0 2.56.27l17.43-9.95Z",
    style: {
      fill: "#263238",
      transformOrigin: "370.201px 433.751px"
    },
    id: "el42ih3e9u1dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61 440.81a10.46 10.46 0 0 0-4.69-8.2 3.34 3.34 0 0 0-3.28-.36L310.31 456l8.62 15.24 43.27-27.38a3.29 3.29 0 0 0 1.41-3.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "336.969px 451.608px"
    },
    id: "elvlccgd7h30i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.93 471.24 43.27-27.38a3.29 3.29 0 0 0 1.41-3.05 9.87 9.87 0 0 0-1.57-5l-47.56 27.54Z",
    style: {
      opacity: 0.1,
      transformOrigin: "339.054px 453.525px"
    },
    className: "animable",
    id: "eltn2p7khtub"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.57 470.78a13.69 13.69 0 0 1-6.15-10.78c0-3.95 2.8-5.54 6.21-3.55a13.71 13.71 0 0 1 6.15 10.75c-.02 3.98-2.78 5.57-6.21 3.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "314.6px 463.615px"
    },
    id: "ellylnkwsaivc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "314.6px 463.615px"
    },
    className: "animable",
    id: "el02jjktfxhbwa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.57 470.78a13.69 13.69 0 0 1-6.15-10.78c0-3.95 2.8-5.54 6.21-3.55a13.71 13.71 0 0 1 6.15 10.75c-.02 3.98-2.78 5.57-6.21 3.58Z",
    id: "el8jimmr5zjdk",
    className: "animable",
    style: {
      transformOrigin: "314.6px 463.615px"
    }
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingMobile);
export default __webpack_public_path__ + "static/media/landingMobile.c5983b7f3e978fde6a4688019c2eec72.svg";
export { ForwardRef as ReactComponent };